import React, { useState, useEffect, useRef, Children, cloneElement, useCallback, useMemo } from 'react';
import { Input, Image, Checkbox, Dropdown, Button, DatePicker, Form, Typography, Drawer, Row, Col, Table, Space, Card, Collapse, Progress, Upload, message, Radio, Tooltip, Menu } from 'antd';
import $, { type } from 'jquery'
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import Link from 'next/link';
import { useSession } from "next-auth/react";

import { DownloadOutlined, UploadOutlined, EyeOutlined, PaperClipOutlined, DeleteOutlined } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";
dayjs.extend(weekday);
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localeData);
import ApiUrl from '../../url.json';
import styles from '../../styles/StdManageWidget.module.css'
import Swal from 'sweetalert2';
import Resumable from 'resumablejs';
import axios from 'axios';
import JSZip from 'jszip';
import { parseStringPromise } from 'xml2js';
// import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns'
import Select, { components } from 'react-select';
import { useRouter } from 'next/router';
import cancelRequests from '../../utils/cancelRequests';

const { TextArea } = Input;
const { Option } = Select;
const { Text } = Typography;
const { Panel } = Collapse;


const customStyles = {
  control: (provided) => ({
    ...provided,
    margin: '5px 0px',
    minHeight: '45px',  // Increase the height of the input field
    // borderColor: 'blue',  // Custom border color
    boxShadow: 'none',  // Remove default box shadow
    '&:hover': {
      borderColor: 'darkblue',  // Change border color on hover
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    // height: '50px',  // Match the control height for consistent padding
    // padding: '10px 16px',  // Adjust padding inside the input field
    padding: '8px 12px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',  // Remove default margin
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,  // Ensure dropdown appears above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? 'white' : 'black',
    backgroundColor: state.isSelected ? 'blue' : 'white',
    '&:hover': {
      backgroundColor: 'lightblue',  // Custom hover color for options
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    // height: 'auto',  // Ensure the indicators container adapts to the control height
    // width: '30px'
  }),
};




export default function StdManageWidget({ open1, setShowWidget, mode, currentSchemaName, currentItemID, currentTitleName, userEditProfile = null, onRefresh, currentStatusActionData, rawJSON, refreshGenericTable }) {
  const { createCancelableAxiosOptions } = cancelRequests();
  // let currentSchemaName = "TestSuite"
  const [formItems, setFormItems] = useState([]);
  const [referenceData, setReferenceData] = useState({});
  const [queryDetail, setQueryDetail] = useState({})
  const [formValues, setFormValues] = useState({});
  const [jobID, setJobID] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [availableActions, setAvailableActions] = useState([]);
  const [actionGenericElement, setactionGenericElement] = useState(null);
  const [genericModalTitle, setgenericModalTitle] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userRole, setUserRole] = useState([]);

  // useEffect(() => {
  //   if (queryDetail && Object.keys(queryDetail).length > 0) {
  //     setFormValues(queryDetail);
  //   }
  // }, [queryDetail]);
  const uploadedFilesRef = useRef({});
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const [fileNameStore, setFileNameStore] = useState('');
  const [isHostCompanyValue, setIsHostCompanyValue] = useState(null);
  const [isHostCompany, setIsHostCompany] = useState(false);
  const [actionMenuItems, setActionMenuItems] = useState([]);
  const [dropdownButtons, setDropdownButtons] = useState([]);
  const [independentButtons, setIndependentButtons] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: session } = useSession();
  // const [isHostCompanyValueForEdit, setIsHostCompanyValueForEdit] = useState('')
  let isHostCompanyValueForEdit = null

  // const [companyDomainValues, setCompanyDomainValues] = useState(null);
  const [emailValue, setEmailValue] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [emailSuggestion, setEmailSuggestion] = useState([]);

  let packageFileName = '';  // use in Edit test suite form 

  let addPackage = false;

  const [rawJsonData, setRawJsonData] = useState({});

  let jsonData = {};
  let formAttribute;
  let tempStorage = {};
  // let listItemArr = [];


  // file uploading
  const [showFileList, setShowFileList] = useState(false);
  const [packages, setPackages] = useState([
    {
      packageId: 1,
      fileList: [],
    },
  ]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [pkgState, setPkgState] = useState({ userName: "empty" });
  const [filesarr, setfilesarr] = useState([]);
  const [errors, setErrors] = useState({});

  const [roleOptions, setRoleOptions] = useState([]);
  const [externalRoleOptions] = useState([
    { value: "External User", label: "External User" }
  ]);

  const fetchRoles = () => {
    let roles = [];

    $.ajax({
      url: `${ApiUrl.newUrl}/api/dbjsonschema/schema/Role`,
      method: "GET",
      async: false,
      success: function (res) {
        if (res?.success && Array.isArray(res.data?.role)) {
          roles = res.data.role
            .filter(r => r.Name !== "External User")
            .map(r => ({
              value: r.Name,
              label: r.Name,
              precedence: r.Precedence
            }));
          setRoleOptions(roles);
        } else {
          console.error("Unexpected API response:", res);
        }
      },
      error: function (xhr, status, error) {
        console.error("Error fetching roles:", error);
      }
    });
    return roles;
  };

  const getHiddenPrecedenceGroups = (selectedRoles) => {
    return new Set(
      selectedRoles
        .map(roleName => {
          const role = roleOptions.find(r => r.value === roleName);
          return role ? Math.floor(role.precedence) : null;
        })
        .filter(Boolean)
    );
  };

  const getFilteredRoleOptions = (selectedRoles) => {
    if (!selectedRoles || selectedRoles.length === 0) return roleOptions;

    const hiddenGroups = getHiddenPrecedenceGroups(selectedRoles);

    return roleOptions.filter(role => {
      const roleGroup = Math.floor(role.precedence);

      if (selectedRoles.includes(role.value)) return true;

      return !hiddenGroups.has(roleGroup);
    });
  };




  const [xmlData, setXmlData] = useState(null);
  const [uploadedFileNames, setUploadedFileNames] = useState({});
  const [originalValues, setOriginalValues] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  const isMountedRef = useRef(true);
  // const main =()=>{
  const mainUploadProps = {
    name: 'file',
    multiple: false,
    action: '',
    accept: '.zip,.7z',
    showUploadList: false, // true, // false
    onChange: (info) => handleFileUpload(info, packages.length) // Pass the packageId
  };
  // }
  function normalizeDayjs(value) {
    return dayjs.isDayjs(value)
      ? value
      : value
        ? dayjs(value)
        : null;
  }
  // json =  GetRawJson(currentItemID, currentSchemaName);
  const createTableComponent = (component, props = {}, children = null) => {
    const element = {};

    const {
      type,
      value,
      id,
      className,
      onChange,
      schemaKey,
      selected,
      placeholder,
      dataError,
      readOnly,
      disabled,
      styles,
      style,
      rows,
      ...otherProps
    } = props;

    if (type) element.type = type.toLowerCase();
    if (id) element.id = id;
    if (schemaKey) element.schemaKey = schemaKey;
    if (className) element.className = className;
    if (onChange) element.onChange = onChange;
    if (placeholder) element.placeholder = placeholder;
    if (dataError) element.dataError = dataError;
    if (readOnly) element.readOnly = readOnly;
    if (disabled) element.disabled = disabled;
    if (styles) element.style = styles;
    if (style) element.style = style;
    if (rows) element.rows = rows;


    if (component === 'input' && type === 'checkbox' && value) {
      element.defaultChecked = value;
    } else if (component === 'input' && type === 'text') {
      element.defaultValue = value;
    } else if (component === 'input') {
      element.defaultValue = value;
    } else if (component === 'textarea') {
      element.defaultValue = value;
    } else if (component === 'option' || component === 'Option') {
      element.selected = selected;
      element.value = value;
    }


    if (['label', 'span', 'button'].includes(component)) {
      return React.createElement(component, element, value);
    }

    if (component === 'select') {
      return React.createElement(component, props, children);
    }

    if (component === 'option') {
      return React.createElement(component, props, children);
    }


    if (component === 'Select') {
      return <Select {...props}>{children}</Select>;
    }

    if (component === 'Option') {
      return <Option {...props}>{children}</Option>;
    }


    if (component === 'DatePicker') {
      return React.createElement(DatePicker, {
        ...element,

        showTime: {
          use12Hours: true,
          format: 'hh:mm A',
        },

        format: 'YYYY-MM-DD hh:mm A',

        value: value ? normalizeDayjs(value) : null,

        onChange: (date, dateString) => {
          updateValue(
            {
              target: {
                id: element.id,
                type: 'datetime',
                value: date,
                valueString: dateString
              }
            },
            element.schemaKey
          );
        }
      });
    }



    if (component === 'table') {
      element.className = 'blueTable';
    }

    return React.createElement(component, element);
  };

  const activeRequests = useRef([]);
  useEffect(() => {
    isMountedRef.current = true;
    const fetchJsonData = async () => {
      setLoading(true)
      let json = {};
      try {
        json = await GetRawJson(currentItemID, currentSchemaName);
        if (!isMountedRef.current) return;
        setRawJsonData(json)
        // console.log('json: ', json)


        switch (mode) {
          case "Create":
            {
              if (currentSchemaName === "Users") {
                fetchRoles()
              }
              if (Object.keys(json).length > 0) {
                LoadCreateContent(json)
                break;
              }
              // LoadCreateContent(jsonData)
              // break;
            }
          case "Edit":
            {
              if (currentItemID) {
                $.ajax({
                  method: "GET",
                  url: ApiUrl.newUrl + '/api/dbjsonschema/schema/' + currentSchemaName + '/id/' + currentItemID,
                  dataType: "json",
                  async: false,
                  headers: { jwt: localStorage.getItem("jwt") },
                  success: function (result) {
                    if (!isMountedRef.current) return;
                    let queryDetail = result.data[currentSchemaName.toLocaleLowerCase()];
                    setQueryDetail(queryDetail)
                    setOriginalValues(queryDetail);
                    // setFormValues(queryDetail)
                    var colSetting;
                    // if (self.currentSchemaColumns) {
                    //     colSetting = JSON.parse(self.currentSchemaColumns);
                    // }
                    // modalTitle = "Edit " + currentSchemaName;

                    if (currentSchemaName === "Users") {
                      const internalRoles = fetchRoles();
                      setRoleOptions(internalRoles);
                      LoadEditContent(json, queryDetail, formAttribute);
                    }
                    else {
                      LoadEditContent(json, queryDetail, formAttribute);
                    }
                  },
                  error: function (xhr, status, error) {
                    if (!isMountedRef.current) return;
                    console.error("Error fetching item details:", status, error);
                  }
                });
              }

              // const LoadEditContent = ({ schemaModel, queryDetail, formAttribute, colSetting }) => {

              break;
            }
          case "View":
            {
              if (currentItemID) {
                $.ajax({
                  method: "GET",
                  url: ApiUrl.newUrl + '/api/dbjsonschema/schema/' + currentSchemaName + '/id/' + currentItemID,
                  dataType: "json",
                  async: false,
                  headers: { jwt: localStorage.getItem("jwt") },
                  success: function (result) {
                    if (!isMountedRef.current) return;
                    let queryDetail = result.data[currentSchemaName.toLocaleLowerCase()];
                    if (currentSchemaName == 'Approval') {
                      setJobID(result.data.approval.JobID);
                    }
                    var colSetting;
                    // if (self.currentSchemaColumns) {
                    //     colSetting = JSON.parse(self.currentSchemaColumns);
                    // }
                    // modalTitle = "Edit " + currentSchemaName;
                    setIsHostCompany(queryDetail['IsHostCompany']);
                    LoadViewContent(json, queryDetail, formAttribute, colSetting, queryDetail['IsHostCompany']);
                    console.log('Successfully fetched item details');
                  },
                  error: function (xhr, status, error) {
                    if (!isMountedRef.current) return;
                    console.error("Error fetching item details:", status, error?.message);
                  }
                });
              }
              break;
            }
        }
      } catch (error) {
        if (!isMountedRef.current) return;
        console.error('Error in fetchJsonData:', error);
      }
      finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    };


    fetchJsonData();
    // if (currentSchemaName == 'Users') {
    //   fetchCompanyDetail();
    // }

    return () => {
      isMountedRef.current = false;
      // activeRequests.current.forEach((req) => req?.abort?.())
      // activeRequests.current = []
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // async function fetchCompanyDetail() {

  //   var displayColumns = ['_id', 'Name', 'IsHostCompany', 'Default Channel', 'Packaging Format', 'Primary Contact', 'Location', 'Status']        // var displayColumns = ['Name', 'UserID', 'User Code', 'Company', 'Role', 'Status', 'Email', 'Location', 'Phone', 'Last Login']        
  //   let filterObject1 = {};
  //   filterObject1["SelectedColumns"] = displayColumns;
  //   let apiPath = ApiUrl.newUrl + "/api/dbjsonschema/schema/Company/filter/AND?limit=100";
  //   var options = {
  //     headers: { jwt: localStorage.getItem("jwt") },
  //   };
  //   try {
  //     var resp = await axios.post(apiPath, { data: filterObject1 }, options);
  //     var { data, error } = resp.data;

  //     let companyDomainArr = []
  //     // console.log('resp: ', resp)

  //     var arr = data.company.map((data1) => {
  //       companyDomainArr.push(data1['companydomain'])
  //       return {
  //         key: data1._id,
  //         userId: data1._id,
  //         companyDetail: {
  //           id: data1._id,
  //           name: data1.Name,
  //           hostCompany: data1.IsHostCompany,
  //           createOn: data1['Created On'],
  //         },
  //         name: data1.Name,
  //         channelFormat: {
  //           channel: data1['Default Channel'],
  //           format: data1['Packaging Format'],
  //         },
  //         // description: data1.Description,

  //         // primaryContact: data1['Primary Contact'],
  //         city: data1.City,
  //         country: data1.Country,
  //         createdBy: data1['Created by'],
  //         // location: {
  //         //     city: data1.City,
  //         //     country: data1.Country
  //         // },
  //         // status: data1.Status == 1 ? 'Active' : 'Inactive',
  //         status: data1.Status == 0 ? 'Inactive' : '' || data1.Status == 1 ? 'Active' : '' || data1.Status == 2 ? 'Draft' : '' || data1.Status == 3 ? 'Obsolete' : '',
  //         allDetails: { data: data1 }
  //       };
  //     });
  //     // setDataSource(arr);
  //     setCompanyDomainValues(companyDomainArr)
  //   }
  //   catch (error) {
  //     console.error(error);
  //   }
  // }
  function LoadCreateContent(schemaModel, reloadValue = null) {
    const items = [];

    const schemaKeys = Object.keys(schemaModel || {});
    const keyIndexMap = Object.fromEntries(schemaKeys.map((k, i) => [k, i]));

    schemaKeys.sort((a, b) => {
      const orderA = schemaModel[a].order !== undefined ? Number(schemaModel[a].order) : Infinity;
      const orderB = schemaModel[b].order !== undefined ? Number(schemaModel[b].order) : Infinity;

      if (orderA !== Infinity && orderB !== Infinity) {
        return orderA - orderB;
      } else if (orderA === Infinity && orderB === Infinity) {
        return keyIndexMap[a] - keyIndexMap[b];
      } else {
        return orderA - orderB;
      }
    });

    for (const schemaKey of schemaKeys) {

      if (schemaModel[schemaKey].editable === false) continue;
      if (schemaKey === 'Status' && schemaModel[schemaKey].editable === true) continue; // only for status field

      let isMultiple = Array.isArray(schemaModel[schemaKey]['type']);
      let attributeType = isMultiple ? schemaModel[schemaKey]['type'][0].toLowerCase() : schemaModel[schemaKey]['type'].toLowerCase();
      let idValue = 'detailField_' + attributeType;
      let userIdValue = 'detailAttr_' + schemaKey;

      let checkType = schemaModel[schemaKey]['type']
      let placeholder = schemaModel[schemaKey]['placeHolder']
      let placeholderValue = 'Enter ' + schemaKey //+ 'Name'

      let mandatoryFiled = schemaModel[schemaKey].required
      let mandatoryFiledError = 'Please fill the ' + schemaKey

      // if (reloadValue !== 'Create') {
      if (reloadValue == null) {
        let type;
        if (checkType == 'String' || checkType == ['ObjectId']
          || checkType == 'Date') {
          type = ''
        }
        else if (Array.isArray(checkType) || checkType == ['ObjectId'] || checkType == 'Array' || checkType == 'number') {
          // checkType == ['ObjectId']
          type = []
        }
        else if (checkType == 'Boolean') {
          type = false;
        }


        if (schemaKey == 'Status') {
          setFormValues((prev) => ({
            ...prev,
            [schemaKey]: "0",
          }))
        }
        // else if (currentSchemaName == "TestSuite" && schemaKey == "Package") {
        //   setFormValues((prev) => ({
        //     ...prev,
        //     [schemaKey]:[ {
        //       packageId: 1,
        //       fileList: [], 
        //     }]
        //   }))
        // }
        else {
          setFormValues((prev) => ({
            ...prev,
            [schemaKey]: type
          }));
        }
      }

      if (currentSchemaName == 'Users' && isHostCompanyValue != null) {
        let type;
        // formValues.Role 
        if (Array.isArray(formValues.Role) && checkType == 'Array') {
          // checkType == ['ObjectId']
          type = []

          setFormValues((prev) => ({
            ...prev,
            [schemaKey]: type
          }));
        }

        if (typeof formValues.Role === 'string' && checkType == 'Array') {
          // setFormValues((prev) => ({
          //   ...prev,
          //   [schemaKey]: formValues.Role
          // }));
          if (isHostCompanyValue) {
            setFormValues((prev) => ({
              ...prev,
              // [schemaKey]: "Internal Admin"
            }));
          }
          else if (isHostCompanyValue == false) {
            setFormValues((prev) => ({
              ...prev,
              [schemaKey]: "External User"
            }));
          }
        }
      }
      let label;
      if (schemaModel[schemaKey].required || schemaKey == 'Approvers' || schemaKey == 'Reviewers') {






        const finalLabel = createTableComponent('label', {
          className: null
          // `${styles['control-label']} ` 
          , value: schemaModel[schemaKey].hasOwnProperty("displayName") && schemaModel[schemaKey].displayName ? schemaModel[schemaKey].displayName.charAt(0).toUpperCase() + schemaModel[schemaKey].displayName.slice(1) : schemaKey.charAt(0).toUpperCase() + schemaKey.slice(1)
        })


        label = finalLabel;


        const requiredSpan = React.createElement(
          'span',
          { className: styles.reqField },
          '*'
        );

        label = React.createElement('span', { className: `${styles['control-label']}` }, finalLabel, requiredSpan)

        // label = (
        //   <>
        //     {label}
        //     <span className={styles.reqField}>*</span>
        //   </>
        // );


      }
      else {
        label = createTableComponent('label', { className: `${styles['control-label']} `, value: schemaKey.charAt(0).toUpperCase() + schemaKey.slice(1) });

      }

      let userInputField;
      switch (attributeType) {
        case 'boolean':
          if (currentSchemaName == 'Company' && schemaKey == 'Approval Required' && isHostCompany == false) {
            userInputField = React.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              React.createElement(
                'label',
                { style: { marginRight: '10px', display: 'flex' } },
                React.createElement('input', {
                  type: 'radio',
                  id: userIdValue + 'true',
                  name: schemaKey,
                  // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                  value: true,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  style: { marginRight: '5px' },
                  onChange: (e) => updateValue(e, schemaKey)
                }),
                'Yes'
              ),
              React.createElement(
                'label',
                { style: { marginRight: '10px', display: 'flex' } },
                React.createElement('input', {
                  type: 'radio',
                  id: userIdValue + 'false',
                  name: schemaKey,
                  // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                  // checked: true,
                  defaultChecked: true,
                  value: false,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  style: { marginRight: '5px' },
                  onChange: (e) => updateValue(e, schemaKey)
                }),
                'No'
              )
            );
            break;
          }
          if (currentSchemaName == 'Company' && schemaKey == 'Approval Required' && isHostCompany == true) {
            break;
          }
          if (currentSchemaName == 'TestSuite' && schemaKey == 'Is Performance?') {


            // console.log(formValues.schemaKey)
            // userInputField = createTableComponent('input', { type: 'checkbox', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrolIsPerformance}`, value: '', onChange: (e) => updateValue(e, schemaKey) });
            //  userInputField = React.createElement('input', { type: 'checkbox', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrolIsPerformance}`, value: '', style: { marginRight: '100px' }, onChange: (e) => updateValue(e, schemaKey) });
            // userInputField = React.createElement('input', {type: 'radio', id: userIdValue, checked: true, value: formValues.schemaKey, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, style: { marginRight: '100px' }, onChange: (e) => updateValue(e, schemaKey)})


            // userInputField = (
            //   <>
            //     <input type='radio' id={`${userIdValue}-true`} onChange={(e)=> updateValue(e,schemaKey)} checked={formValues && formValues[schemaKey] == true}  value={true}/>
            //     <label htmlFor=''>Yes</label>
            //     <input type='radio' id={`${userIdValue}-false`} onChange={(e)=> updateValue(e,schemaKey)} checked={formValues && formValues[schemaKey] != true} value={false}/>
            //     <label htmlFor=''>No</label> 
            //   </>
            // )

            userInputField = React.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              React.createElement(
                'label',
                { style: { marginRight: '10px', display: 'flex' } },
                React.createElement('input', {
                  type: 'radio',
                  id: userIdValue + 'true',
                  name: schemaKey,
                  // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                  value: true,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  style: { marginRight: '5px' },
                  onChange: (e) => updateValue(e, schemaKey)
                }),
                'Yes'
              ),
              React.createElement(
                'label',
                { style: { marginRight: '10px', display: 'flex' } },
                React.createElement('input', {
                  type: 'radio',
                  id: userIdValue + 'false',
                  name: schemaKey,
                  // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                  // checked: true,
                  defaultChecked: true,
                  value: false,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  style: { marginRight: '5px' },
                  onChange: (e) => updateValue(e, schemaKey)
                }),
                'No'
              )
            );
          }
          else {
            // userInputField = createTableComponent('input', { type: 'checkbox', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, value: '', onChange: (e) => updateValue(e, schemaKey) });
            userInputField = React.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              React.createElement(
                'label',
                { style: { marginRight: '10px', display: 'flex' } },
                React.createElement('input', {
                  type: 'radio',
                  id: userIdValue + 'true',
                  name: schemaKey,
                  // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                  value: true,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  style: { marginRight: '5px' },
                  onChange: (e) => updateValue(e, schemaKey)
                }),
                'Yes'
              ),
              React.createElement(
                'label',
                { style: { marginRight: '10px', display: 'flex' } },
                React.createElement('input', {
                  type: 'radio',
                  id: userIdValue + 'false',
                  name: schemaKey,
                  // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                  // checked: true,
                  defaultChecked: true,
                  value: false,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  style: { marginRight: '5px' },
                  onChange: (e) => updateValue(e, schemaKey)
                }),
                'No'
              )
            );
          }
          break;

        case 'number': {

          if (schemaModel[schemaKey]['oneOf']) {
            userInputField = createTableComponent(
              'select',
              { id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) },
              schemaModel[schemaKey]['oneOf'].map((opt, i) => (
                createTableComponent('option', {
                  key: i,
                  value: opt.enum && opt.enum.values().next().value,
                  selected: opt.title == "Inactive"

                }, opt.title)
              ))
            );


          } else {
            userInputField = createTableComponent('input', { type: 'number', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) });
          }
          // console.log('userInputField: ', userInputField)
          break;



        }
        case 'date':
          userInputField = createTableComponent('DatePicker', { type: 'Date', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), schemaKey });
          break;
        case 'objectid': {

          // if ( schemaKey != 'Package') {
          let options = "";
          let resultData;
          let refOpt;
          let reference = schemaModel[schemaKey]['ref'];
          // reference = schemaModel[schemaKey]['ref'] == 'TestEnvironment' && 'Test_Environment'
          if (reference && !tempStorage.hasOwnProperty(reference.toLowerCase())) {
            $.ajax({
              type: 'GET',
              url: ApiUrl.newUrl + '/api/dbjsonschema/schema/' + reference,
              dataType: 'json',
              async: false,
              headers: { jwt: localStorage.getItem("jwt") },
              success: function (result) {
                console.log('Create content loaded');
                tempStorage[reference.toLowerCase()] = result.data[reference.toLowerCase()].filter(item => item.Status == 1);
                resultData = result.data[reference.toLowerCase()].filter(item => item.Status == 1);
              },
              error: function (xhr, status, error) {
                console.error("Error fetching data:", status, error);
              }

            });

          }
          else if (tempStorage.hasOwnProperty(reference.toLowerCase())) {
            resultData = tempStorage[reference.toLowerCase()];

          }

          // console.log('resultData: ', resultData)

          if (isMultiple) {



            let multiOptions;

            if (currentSchemaName === 'Groups') {
              multiOptions = resultData
                .filter(ref =>
                  ref.Role.includes('Internal Admin') || ref.Role.includes('Internal User')
                )
                .map(ref => ({
                  value: ref._id,
                  label: ref.Name,
                }));
            } else if (currentSchemaName === "Company") {
              var companyData = [];
              $.ajax({
                type: 'GET',
                url: ApiUrl.newUrl + '/api/dbjsonschema/schema/Company',
                dataType: 'json',
                async: false,
                headers: { jwt: localStorage.getItem("jwt") },
                success: function (result) {
                  companyData = result.data['company'].filter(item => item.Status == 1);
                },
                error: function (xhr, status, error) {
                  console.error("Error fetching data:", status, error);
                }

              });

              multiOptions = resultData
                .filter(ref => {
                  const userCompany = companyData.find(item => item._id === ref.Company);
                  return userCompany && userCompany.IsHostCompany === true;
                })
                .map(ref => ({
                  value: ref._id,
                  label: ref.Name
                }));
            }
            else {
              multiOptions = resultData.map(ref => ({
                value: ref._id,
                label: ref.Name,
              }));
            }
            // console.log('multiOptions', multiOptions);
            if (schemaKey == 'Receivers') {
              if (isHostCompany == false) {
                userInputField = React.createElement(
                  Select,
                  {
                    id: userIdValue,

                    styles: customStyles,
                    // className: `${styles.inputBoxStyleMultiSelectDropdown}`,
                    // style: {margin: '5px 0', height: '58px'},
                    'data-live-search': true,
                    title: `Select ${schemaKey}`,
                    placeholder: `Select ${schemaKey}`,
                    //  multiple: isMultiple,
                    //  mode: isMultiple ? 'multiple' : undefined,
                    isMulti: true,
                    onChange: (e) => updateDropdownValue(e, schemaKey),
                    options: multiOptions
                  },
                )
              }
              else if (isHostCompany == true) { continue }
            }
            else {
              userInputField = React.createElement(
                Select,
                {
                  id: userIdValue,

                  styles: customStyles,
                  // className: `${styles.inputBoxStyleMultiSelectDropdown}`,
                  // style: {margin: '5px 0', height: '58px'},
                  'data-live-search': true, title: `Select ${schemaKey}`, placeholder: schemaKey == 'Test Suites' ? `Select Test Suite(s)` : `Select ${schemaKey}`,
                  //  multiple: isMultiple,
                  //  mode: isMultiple ? 'multiple' : undefined,
                  isMulti: true,
                  onChange: (e) => updateDropdownValue(e, schemaKey),
                  options: multiOptions


                },

              )
            }
          }
          else {
            if (currentSchemaName == 'Company' && (schemaKey == 'Approvers' || schemaKey == 'Reviewers') && isHostCompany == true) {
              userInputField = createTableComponent(
                'select',
                // 'option',
                {
                  id: userIdValue,
                  //  className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
                  className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  'data-live-search': true, title: 'None', multiple: isMultiple,
                  //  placeholder: `Select ${schemaKey}`,
                  mode: isMultiple ? 'multiple' : undefined, onChange: (e) => updateValue(e, schemaKey, currentSchemaName == 'Users' && schemaKey == 'Company' && resultData)
                },
                [
                  createTableComponent('option', {
                    value: "", key: 'default',
                    // selected: !resultData,
                    selected: true,
                    // style: {color: 'gray'},
                    // className: `${styles.selected}`,
                    hidden: true,
                    disabled: true,
                    // id: 0
                  },
                    `Select ${schemaKey}`),
                  resultData && resultData.map((ref, index) => (
                    createTableComponent('option', { key: index, value: ref._id, isHostCompany: currentSchemaName == 'Users' && schemaKey == 'Company' && ref.IsHostCompany }, ref.Name)
                  ))
                ]
              )
              break;
            } else if (currentSchemaName == 'Company' && (schemaKey == 'Approvers' || schemaKey == 'Reviewers') && isHostCompany == false) {
              break;
            } else if (currentSchemaName == 'Groups' && schemaKey == 'Manager') {
              resultData = resultData.filter(ref => ref.Role.includes('Internal Manager') && ref.Role.includes('Internal User'));
            }
            userInputField = createTableComponent(
              'select',
              // 'option',
              {
                id: userIdValue,
                //  className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                'data-live-search': true, title: 'None', multiple: isMultiple,
                //  placeholder: `Select ${schemaKey}`,
                mode: isMultiple ? 'multiple' : undefined, onChange: (e) => {
                  updateValue(e, schemaKey, currentSchemaName == 'Users' && schemaKey == 'Company' && resultData)
                  setFormValues((prev) => ({ ...prev, Role: [] }));
                  setUserRole([]);
                }
              },
              [
                createTableComponent('option', {
                  value: "", key: 'default',
                  // selected: !resultData,
                  selected: true,
                  // style: {color: 'gray'},
                  // className: `${styles.selected}`,
                  hidden: true,
                  disabled: true,
                  // id: 0
                },
                  `Select ${schemaKey}`),
                resultData && resultData.map((ref, index) => (
                  createTableComponent('option', { key: index, value: ref._id, isHostCompany: currentSchemaName == 'Users' && schemaKey == 'Company' && ref.IsHostCompany }, ref.Name)
                ))
              ]
            )
          }

          break;

        }

        case "array": {
          if (currentSchemaName === "Users" && schemaKey === "Role") {
            userInputField = (
              <div>
                <Select
                  id={userIdValue}
                  isMulti
                  // className={styles.InputBoxStyle}
                  styles={customStyles}
                  isDisabled={isHostCompanyValue == null}
                  options={
                    isHostCompanyValue
                      ? getFilteredRoleOptions(userRole)
                      : externalRoleOptions
                  }
                  value={userRole.map(v => ({ value: v, label: v }))}
                  onChange={(selected) => {
                    const newValue = selected ? selected.map(opt => opt.value) : [];
                    setUserRole(newValue);

                    setFormValues((prev) => {
                      let updated = { ...prev, Role: newValue };

                      updated = handleRoleCompanyDependency(updated, "Role");

                      // dirty check
                      const dirty = Object.keys(updated).some((key) => {
                        let updatedVal = updated[key] === "" ? null : updated[key];
                        let originalVal = originalValues[key] === "" ? null : originalValues[key];

                        if (Array.isArray(originalVal) && originalVal.length === 1 && typeof updatedVal === "string") {
                          originalVal = originalVal[0];
                        }
                        if (Array.isArray(updatedVal) && updatedVal.length === 1 && typeof originalVal === "string") {
                          updatedVal = updatedVal[0];
                        }

                        return updatedVal !== originalVal;
                      });

                      setIsDirty(dirty);
                      return updated;
                    });
                  }}
                  placeholder={`Select ${schemaKey}`}
                />
              </div>
            );
          } else {
            userInputField = createTableComponent("input", {
              type: "text",
              id: userIdValue,
              className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
              onChange: (e) => updateValue(e, schemaKey),
            });
          }
          break;
        }

        case 'string': {
          if (schemaModel[schemaKey]['oneOf']) {

            userInputField = createTableComponent(
              'select',
              {
                id: userIdValue,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                onChange: (e) => updateValue(e, schemaKey),
                'data-live-search': true, title: 'None', multiple: isMultiple,
                mode: isMultiple ? 'multiple' : undefined
              },
              [
                createTableComponent('option', {
                  value: "", key: 'default',
                  selected: true,
                  // style: {color: 'gray'},
                  // className: `${styles.selected}`,
                  hidden: true,
                  disabled: true,
                  // defaultValue: true
                },
                  `Select ${schemaKey}`),

                schemaModel[schemaKey]['oneOf'].map((opt, i) => (
                  // <Option key={i} value={opt.title}>{opt.title}</Option>
                  createTableComponent('option', { key: i, value: opt.title }, opt.title)
                ))
              ]);
          }
          else if (schemaModel[schemaKey]["isFile"]) {
            const uploadField = React.createElement(
              Upload,
              {
                accept: '*',
                id: 'btnUpload' + schemaKey,
                multiple: true,
                defaultFileList: uploadedFilesRef.current[schemaKey]?.map((f, index) => ({
                  uid: index,
                  name: f.name || f,
                  status: 'done',
                  originFileObj: f
                })) || [],
                onChange: (info) => {
                  if (info.fileList && info.fileList.length > 0) {
                    uploadedFilesRef.current[schemaKey] = info.fileList.map(f => f.originFileObj || f.name);
                    updateValue(
                      { target: { id: 'btnUpload' + schemaKey, type: "file", value: info.fileList.map(f => f.name) } },
                      schemaKey
                    );
                  } else {
                    uploadedFilesRef.current[schemaKey] = [];
                    updateValue(
                      { target: { id: 'btnUpload' + schemaKey, type: "file", value: [] } },
                      schemaKey
                    );
                  }
                },
                beforeUpload: () => false
              },
              React.createElement(Button, { type: 'primary' }, 'Browse')
            );

            userInputField = React.createElement(
              'div',
              { className: styles.uploadWrapper },
              [uploadField]
            );
          }

          else {

            if (currentSchemaName == 'Users' && schemaKey == 'UserID' && formValues['Role'] == 'External User') {
              {
                userInputField = React.createElement('input', {
                  type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  placeholder: placeholder ? `${placeholderValue} Name` : '', required: mandatoryFiled, onChange: (e) => updateValue(e, schemaKey),
                  readOnly: true,
                  value: formValues[schemaKey]
                })
              }
            } else {
              {
                schemaKey == 'Description' ? userInputField = createTableComponent('textarea', { rows: '2', type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', required: mandatoryFiled, onChange: (e) => updateValue(e, schemaKey), style: { marginBottom: '-14px' } }) :
                  userInputField = createTableComponent('input', {
                    type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', required: mandatoryFiled, onChange: (e) => updateValue(e, schemaKey),
                    readOnly: currentSchemaName == 'Users' && schemaKey == 'UserID' && formValues['Role'] == 'External User' ? true : false,
                  });
              }
            }
          }
          break;
        }
        case 'object':
          userInputField = createTableComponent('a', { id: userIdValue, value: 'Edit', className: `${styles.InputBoxStyle} ${styles.objectEdit} ${styles.formcontrol}` });
          break;
        default:
          break;
      }

      if (userInputField) {
        let newErrors = {}
        if (schemaModel[schemaKey].required && attributeType !== 'boolean') {
          userInputField = React.cloneElement(userInputField, {
            required: true,
            'data-error': 'Please fill the ' + schemaKey,
          })
        }
        if (currentSchemaName == 'TestSuite' && schemaKey == 'Package') {
          userInputField = React.createElement('input', {
            type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true, placeholder: 'Select Package Zip File',
            value: fileNameStore,
          },
          )
          const deleteButton = (
            <Button id='deleteButtonId' onClick={() => handleFileRemove(schemaKey)} style={{ cursor: 'pointer' }}
              type='ghost'>Delete
            </Button>
          )



          items.push(
            <>
              <div key={idValue} id={idValue} className={`${schemaKey == 'Is Performance?' ? styles.formRowIsPerformance : styles.formRow}`} //className="form-row form-group"
              >
                {label}

                {/* <input type="text" id={userIdValue} readOnly defaultValue={fileNameStore} className={`${styles.InputBoxStyle} ${styles.formcontrol}`} /> */}

                {userInputField}
                {/* {removeButton}  */}
              </div>
              <span id='buttons-id' style={{
                marginTop: '50px',
                // float: 'right', 
                marginRight: '-18px'
              }}>


                <Upload
                  {...mainUploadProps}
                  // disabled={packages[0]['fileList'].length != 0}
                  id='browseButtonId'
                >
                  <Button type="primary">Browse</Button>
                </Upload>

              </span>
            </>
          );
        }
        else {
          items.push(
            <div key={idValue} id={idValue} className={schemaKey == 'Is Performance?' ? styles.formRowIsPerformance : styles.formRow} //className="form-row form-group"
            >
              {label}
              {userInputField}
              {currentSchemaName == 'Users' && schemaKey == 'Email' && emailErrorMessage && <div className="error-message" style={{ color: 'red' }}>{emailErrorMessage}</div>}
              {errors[schemaKey] && <div className="error-message" style={{ color: 'red' }}>{errors[schemaKey]}</div>}
              <div className="help-block with-errors"></div>
            </div>
          );
        }
      }
    }



    setFormItems(items);

    return items;
  }




  const ProcessEditContent = (schemaModel, queryDetail, formAttribute, filteredData, attribute, reloadValue) => {
    // const [jsonData, setJsonData] = useState({});
    // console.log(queryDetail)
    let items = []
    // formAttribute = []
    // const [formValue, setFormValue] = useState(queryDetail)
    let formValue = {};

    let xmlAndBatch = {}

    // useEffect(() => {
    const arrayToString = JSON.stringify(Object.assign({}, filteredData));
    const stringToJsonObject = JSON.parse(arrayToString);
    const tempJsonData = {};

    for (let key in stringToJsonObject) {
      const d = stringToJsonObject[key];
      const columnName = stringToJsonObject[key].id;
      delete d["id"];
      tempJsonData[columnName] = d;
    }
    // setJsonData(tempJsonData);
    jsonData = tempJsonData
    // }, [filteredData]);

    if (currentSchemaName == 'TestSuite') {
      if (schemaModel['Package']['ref'] == "Package") {

        let reference = schemaModel['Package']['ref'];
        // let propVal = queryDetail[schemaKey];
        // let strPropVal = Array.isArray(propVal) ? propVal.join() : propVal;
        // let packageId = queryDetail['Package']
        let pkgId = Array.isArray(queryDetail['Package']) ? queryDetail['Package'][0] : queryDetail['Package'];


        $.ajax({
          type: 'GET',
          url: ApiUrl.newUrl + '/api/dbjsonschema/getPackageInfo/' + reference + '/' + pkgId,
          dataType: 'json',
          async: false,
          headers: { jwt: localStorage.getItem("jwt") },
          success: function (result) {
            console.log('Successfully fetched package info');
            if (result) {

              // fileList[0]['File Name']
              let packageFileId = Array.isArray(result.data[0]['PackageFile']) ? result.data[0]['PackageFile'].shift() : result.data[0]['PackageFile'];

              if (result.data[0]['PackageFile']) {
                $.ajax({
                  type: 'GET',
                  url: ApiUrl.newUrl + '/api/dbjsonschema/getPackageInfo/' + 'PackageFile' + '/' + packageFileId,
                  dataType: 'json',
                  async: false,
                  headers: { jwt: localStorage.getItem("jwt") },
                  success: function (result1) {

                    console.log('Successfully fetched package file details');

                    if (result1) {
                      setPackages([{
                        packageId: 1,
                        fileList: result1.data,
                      }])
                      setFileNameStore(result1.data[0]['File Name'])
                      packageFileName = result1.data[0]['File Name']
                      setShowFileList(true);
                    }
                  },
                  error: function (xhr, status, error) {
                    console.error("Error fetching package file details:", status, error);
                  }

                });
              }

              xmlAndBatch = {
                'Batch File': result.data[0]['Batch File'],
                'XML File': result.data[0]['XML File']
              }

              // setFormValues(xmlAndBatch)

            }

            // tempStorage[reference.toLowerCase()] = result.data[reference.toLowerCase()]
            // resultData = result.data[reference.toLowerCase()];
          },
          error: function (xhr, status, error) {
            console.error("Error fetching package info:", status, error);
          }

        });

      }

    }

    const sortedKeysEdit = Object.keys(tempJsonData);
    const keyIndexMapEdit = Object.fromEntries(sortedKeysEdit.map((k, i) => [k, i]));

    sortedKeysEdit.sort((a, b) => {
      const orderA = schemaModel[a].order !== undefined ? Number(schemaModel[a].order) : Infinity;
      const orderB = schemaModel[b].order !== undefined ? Number(schemaModel[b].order) : Infinity;

      if (orderA !== Infinity && orderB !== Infinity) {
        return orderA - orderB;
      } else if (orderA === Infinity && orderB === Infinity) {
        return keyIndexMapEdit[a] - keyIndexMapEdit[b];
      } else {
        return orderA - orderB;
      }
    });

    for (let schemaKey of sortedKeysEdit) {

      if (reloadValue !== 'Edit') {
        if ([schemaKey] == 'Batch File') {
          setFormValues((prev) => ({
            ...prev,
            [schemaKey]: xmlAndBatch['Batch File'],
          }))
        } else if ([schemaKey] == 'XML File') {
          setFormValues((prev) => ({
            ...prev,
            [schemaKey]: xmlAndBatch['XML File'],
          }))
        }
        else {
          setFormValues((prev) => ({
            ...prev,
            [schemaKey]: queryDetail[schemaKey]
            // [schemaKey]: schemaKey == 'Test Suites'? queryDetail['TestSuiteRun'] : queryDetail[schemaKey],
          }))
        }
      }


      // if ([schemaKey] != 'Batch File' || [schemaKey] != 'XML File') {
      //   setFormValues((prev) => ({
      //     ...prev,
      //     [schemaKey]: 
      //                        xmlAndBatch['Batch File']
      //     //  ([schemaKey] == 'Batch File' || [schemaKey] == 'XML File') ? (xmlAndBatch['Batch File'] || xmlAndBatch['XML File']) : queryDetail[schemaKey],
      //   }))
      // }


      let listItem;

      const hasValue = queryDetail.hasOwnProperty(schemaKey);
      // console.log(schemaKey)
      // console.log(queryDetail[schemaKey])
      let canDisplay = schemaModel[schemaKey].hasOwnProperty("visible") ? schemaModel[schemaKey].visible : true;
      if (schemaKey === "Approval Required" && isHostCompany) canDisplay = false;
      if (schemaKey === "Approvers" && !isHostCompany) canDisplay = false;
      if (schemaKey === "Reviewers" && !isHostCompany) canDisplay = false;

      if (canDisplay) {
        let isMultiple = false
        let attributeType = ""
        if (Array.isArray(schemaModel[schemaKey]['type'])) {
          attributeType = schemaModel[schemaKey]['type'][0].toLowerCase()
          isMultiple = true
        } else {
          attributeType = schemaModel[schemaKey]['type'].toLowerCase();
        }
        const isAttrEditable = schemaModel[schemaKey]['editable'];
        const idValue = 'detailField_' + attributeType;
        const userIdValue = 'detailAttr_' + schemaKey;

        const placeholder = schemaModel[schemaKey]['placeHolder']
        const placeholderValue = 'Enter ' + schemaKey




        // const commonProps = {
        //     id: userIdValue,
        //     className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
        //     id: schemaKey,
        //     value: queryDetail[schemaKey] || '',
        //     onChange: (e) => updateValue(e, schemaKey)
        // };

        // listItem = createComponent('li', { type: '', id: idValue, className: 'form-row form-group'});
        listItem = createTableComponent('li', { type: '', id: idValue, className: 'form-row form-group' });

        let label = createTableComponent('label', { className: styles['control-label'], value: schemaModel[schemaKey].hasOwnProperty("displayName") && schemaModel[schemaKey].displayName ? schemaModel[schemaKey].displayName.charAt(0).toUpperCase() + schemaModel[schemaKey].displayName.slice(1) : schemaKey.charAt(0).toUpperCase() + schemaKey.slice(1) });

        if (schemaModel[schemaKey].required || schemaKey === 'Approvers' || schemaKey === 'Reviewers') {
          label = (
            <>
              {label}
              <span className={styles.reqField}>*</span>
            </>
          );
        }
        // if (schemaModel[schemaKey].hasOwnProperty("required") && schemaModel[schemaKey].required) {
        //     // const spanReq = createTableComponent('span', '', '*', '', 'reqField');
        //     // const spanReq = 
        //    listItem = createTableComponent('span',{type: '',value:'*', id: '', className:`${styles.reqField}` });

        //     // label.appendChild(spanReq);
        // }


        // listItem.appendChild(label);

        let userInputField;
        // Logic for creating userInputField based on attributeType...
        // Replace your jQuery manipulations with appropriate React code

        if (attributeType == 'boolean') {
          userInputField = React.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(
              'label',
              { style: { marginRight: '10px', display: 'flex' } },
              React.createElement('input', {
                type: 'radio',
                id: userIdValue + 'true',
                name: schemaKey,
                // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                value: true,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                style: { marginRight: '5px' },
                onChange: (e) => updateValue(e, schemaKey)
              }),
              'Yes'
            ),
            React.createElement(
              'label',
              { style: { marginRight: '10px', display: 'flex' } },
              React.createElement('input', {
                type: 'radio',
                id: userIdValue + 'false',
                name: schemaKey,
                // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                // checked: true,
                defaultChecked: true,
                value: false,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                style: { marginRight: '5px' },
                onChange: (e) => updateValue(e, schemaKey)
              }),
              'No'
            )
          );
          // userInputField = createTableComponent('input', { id: userIdValue, type: 'checkbox', className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) })
          if (hasValue) {
            let isChecked = queryDetail[schemaKey]
            // if (isChecked) {

            if (schemaKey == 'Is Performance?') {
              userInputField = React.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(
                  'label',
                  { style: { marginRight: '10px', display: 'flex' } },
                  React.createElement('input', {
                    type: 'radio',
                    id: userIdValue + 'true',
                    name: schemaKey,
                    // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                    //  defaultChecked: formValues && formValues[schemaKey] == true,
                    defaultChecked: queryDetail[schemaKey] == true,
                    value: true,
                    className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                    style: { marginRight: '5px' },
                    onChange: (e) => updateValue(e, schemaKey)
                  }),
                  'Yes'
                ),
                React.createElement(
                  'label',
                  { style: { marginRight: '10px', display: 'flex' } },
                  React.createElement('input', {
                    type: 'radio',
                    id: userIdValue + 'false',
                    name: schemaKey,
                    // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                    // checked: true,
                    // defaultChecked: formValues && formValues[schemaKey] != true,
                    defaultChecked: queryDetail[schemaKey] == false,
                    // defaultChecked: true,
                    value: false,
                    className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                    style: { marginRight: '5px' },
                    onChange: (e) => updateValue(e, schemaKey)
                  }),
                  'No'
                )
              );
            }
            else {
              // userInputField = createTableComponent('input', { id: userIdValue, type: 'checkbox', className: `${styles.InputBoxStyle} ${styles.formcontrol}`, value: 'checked', onChange: (e) => updateValue(e, schemaKey) })

              userInputField = React.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(
                  'label',
                  { style: { marginRight: '10px', display: 'flex' } },
                  React.createElement('input', {
                    type: 'radio',
                    id: userIdValue + 'true',
                    name: schemaKey,
                    // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                    //  defaultChecked: formValues && formValues[schemaKey] == true,
                    defaultChecked: queryDetail[schemaKey] == true,
                    value: true,
                    className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                    style: { marginRight: '5px' },
                    onChange: (e) => updateValue(e, schemaKey)
                  }),
                  'Yes'
                ),
                React.createElement(
                  'label',
                  { style: { marginRight: '10px', display: 'flex' } },
                  React.createElement('input', {
                    type: 'radio',
                    id: userIdValue + 'false',
                    name: schemaKey,
                    // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                    // checked: true,
                    // defaultChecked: formValues && formValues[schemaKey] != true,
                    defaultChecked: queryDetail[schemaKey] == false,
                    // defaultChecked: true,
                    value: false,
                    className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                    style: { marginRight: '5px' },
                    onChange: (e) => updateValue(e, schemaKey)
                  }),
                  'No'
                )
              );
            }
            // }
          }

        }
        else if (attributeType == 'number') {
          if (schemaModel[schemaKey]['oneOf']) {

            userInputField = createTableComponent(
              'select',
              {
                id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true,
                style: { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' }
              },
              schemaModel[schemaKey]['oneOf'].map((opt, i) => (
                // <Option key={i} value={opt.title}>{opt.title}</Option>
                createTableComponent('option', {
                  key: opt.enum,
                  value: opt.enum,
                  selected: opt.enum == queryDetail[schemaKey]
                }, opt.title)
              ))
            );


          } else {
            if (hasValue) {
              userInputField = createTableComponent('input', { type: 'number', id: userIdValue, value: queryDetail[schemaKey], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) });
              // userInputField = createTableComponent('input', 'number', queryDetail[schemaKey],userIdValue, `${styles.InputBoxStyle} ${styles.formcontrol}` )

            }
            else {
              userInputField = createTableComponent('input', { type: 'number', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) });
              // userInputField = createTableComponent('input', 'number', '', userIdValue, `${styles.InputBoxStyle} ${styles.formcontrol}` );

            }
          }

        }
        else if (attributeType.toLowerCase() == 'objectid') {

          let options = "";
          let resultData;
          let refOpt;
          let reference = schemaModel[schemaKey]['ref'];
          let propVal = queryDetail[schemaKey];
          let strPropVal = Array.isArray(propVal) ? propVal.join() : propVal;

          let ajaxUrl = isAttrEditable ? '/api/dbjsonschema/schema/' + reference :
            '/api/dbjsonschema/schema/' + reference + '/id/' + strPropVal;

          const cacheKey = `${currentSchemaName}_${schemaKey}`
            .toLowerCase()
            .replace(/\s+/g, '_');

          if (reference && !tempStorage.hasOwnProperty(cacheKey) && strPropVal) {
            $.ajax({
              type: 'GET',
              url: ApiUrl.newUrl + ajaxUrl,
              dataType: 'json',
              async: false,
              headers: { jwt: localStorage.getItem("jwt") },
              success: function (result) {
                tempStorage[reference.toLowerCase()] = result.data[reference.toLowerCase()]
                resultData = result.data[reference.toLowerCase()];
              },
              error: function (xhr, status, error) {
                console.error("Error fetching data:", status, error);
              }
            });
          }
          else if (tempStorage.hasOwnProperty(reference.toLowerCase())) {
            resultData = tempStorage[reference.toLowerCase()];
          }

          if (resultData != undefined) {
            resultData = Array.isArray(resultData) ? resultData : [resultData];
          }

          resultData.map((arr) => {
            if (currentSchemaName == 'Users' && schemaKey == 'Company' && queryDetail[schemaKey].includes(arr._id)) {
              // setIsHostCompanyValueForEdit(arr.IsHostCompany)
              isHostCompanyValueForEdit = arr.IsHostCompany
            }
          })

          if (currentSchemaName === 'Groups' && schemaKey === 'Manager') {
            resultData = resultData
              .filter(ref =>
                ref.Role.includes('Internal Manager') && ref.Role.includes('Internal User')
              )
          }
          // console.log(isHostCompanyValueForEdit)
          if (hasValue) {

            if (!isMultiple) {
              // Array.isArray(queryDetail[schemaKey]) && queryDetail[schemaKey].map((ele, index) => (

              userInputField = createTableComponent('select', {
                id: userIdValue,
                // className: 'formcontrol refObj show-tick',
                className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
                'data-live-search': true,
                // type: '',
                title: 'None',
                multiple: isMultiple,
                // value: ele,
                defaultValue: queryDetail[schemaKey],
                onChange: (e) => {
                  if (schemaKey === "Company") {
                    updateDropdownValue([], "Role");
                  }
                  updateValue(e, schemaKey, currentSchemaName == 'Users' && schemaKey == 'Company' && resultData)
                },
                disabled: (isAttrEditable === true) && !(userEditProfile == 'userEditProfile' && schemaKey == "Company") ? false : true,

                style: (isAttrEditable === true) && !(userEditProfile == 'userEditProfile' && schemaKey == "Company") ? {} : { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' }
              },
                [
                  createTableComponent('option', {
                    value: "", key: 'default',

                    hidden: true,
                    disabled: true
                  },
                    'Please select...'),
                  //  ...resultData.map((arr, i)=>(
                  //    Array.isArray(queryDetail[schemaKey]) && queryDetail[schemaKey].map((ele, index)=>(
                  resultData && resultData.map((arr, i) => (

                    // if (ele == arr._id) {
                    // userInputField = 
                    // console.log('arr: ',arr)
                    // ele == arr._id ? 
                    createTableComponent('option', {
                      key: arr._id,
                      // id: arr._id,
                      value: arr._id,
                      // selected: hasValue && (isMultiple ? queryDetail[schemaKey].includes(arr._id) : '' //arr._id === ele
                      selected: queryDetail[schemaKey].includes(arr._id)
                      //  && (queryDetail[schemaKey].includes(arr._id) && setIsHostCompanyValueForEdit(arr.IsHostCompany))


                    }, arr.Name
                    )
                    // :''

                  ))
                  //  ))
                ]
              )
              // )
              // )

            }
            else {
              // userInputField = React.createElement(Select, {
              //   id: userIdValue,
              //   // className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
              //   className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
              //   style: { padding: '0px' },
              //   'data-live-search': true,
              //   placeholder: schemaKey == 'Test Suites' && `Select Test Suite(s)`,
              //   title: 'None',
              //   multiple: isMultiple,
              //   // value: queryDetail[schemaKey],
              //   defaultValue: queryDetail[schemaKey],
              //   onChange: (e) => updateDropdownValue(e, schemaKey),
              //   mode: isMultiple ? 'multiple' : undefined
              // },
              //   [
              //     // React.createElement(Option, {
              //     //   value: 0, key: 'default',
              //     //   id: 0,
              //     //   // selected: true // hasValue && (isMultiple ? queryDetail[schemaKey].includes(id) : id === ele)
              //     // },
              //     //   'Please select...'),

              //     resultData.map((ele, index) => (
              //       React.createElement(Option, {
              //         key: ele._id,
              //         value: ele._id,
              //         //  selected: hasValue && (isMultiple ? queryDetail[schemaKey].includes(arr._id) : arr._id === ele)
              //         selected: queryDetail[schemaKey].includes(ele._id)

              //       }, ele.Name)
              //     ))
              //   ]
              // )

              // ))


              let multiOptions;
              if (currentSchemaName === 'Groups') {
                multiOptions = resultData
                  .filter(ref =>
                    ref.Role.includes('Internal Admin') || ref.Role.includes('Internal User')
                  )
                  .map(ref => ({
                    value: ref._id,
                    label: ref.Name,
                  }));
              } else if (currentSchemaName === "Company") {
                var companyData = [];
                $.ajax({
                  type: 'GET',
                  url: ApiUrl.newUrl + '/api/dbjsonschema/schema/Company',
                  dataType: 'json',
                  async: false,
                  headers: { jwt: localStorage.getItem("jwt") },
                  success: function (result) {
                    companyData = result.data['company'].filter(item => item.Status == 1);
                  },
                  error: function (xhr, status, error) {
                    console.error("Error fetching data:", status, error);
                  }

                });

                multiOptions = resultData
                  .filter(ref => {
                    const userCompany = companyData.find(item => item._id === ref.Company);
                    return userCompany && userCompany.IsHostCompany === true;
                  })
                  .map(ref => ({
                    value: ref._id,
                    label: ref.Name
                  }));
              } else {
                multiOptions = resultData.map(ref => ({
                  value: ref._id,
                  label: ref.Name,
                }));
              }

              // console.log('multiOptions', multiOptions);

              const selectedOptions = []
              // resultData.filter((option) => {
              resultData.map((option) => {
                if (queryDetail[schemaKey].includes(option._id)) {
                  selectedOptions.push({
                    value: option._id,
                    label: option.Name,
                  })
                }

              })
              // console.log(selectedOptions)

              const nonEditableStyles = {
                control: (provided) => ({
                  ...provided,
                  margin: '5px 0px',
                  minHeight: '50px',  // Increase the height of the input field
                  // borderColor: 'blue',  // Custom border color
                  // readOnly: true,
                  // isDisabled: true,
                  cursor: 'not-allowed',
                  boxShadow: 'none',  // Remove default box shadow
                  '&:hover': {
                    borderColor: 'darkblue',  // Change border color on hover
                  },
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  // height: '50px',  // Match the control height for consistent padding
                  padding: '10px 16px',  // Adjust padding inside the input field
                }),
                input: (provided) => ({
                  ...provided,
                  margin: '0px',  // Remove default margin
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,  // Ensure dropdown appears above other elements
                }),
                option: (provided, state) => ({
                  ...provided,
                  color: state.isSelected ? 'white' : 'black',
                  backgroundColor: state.isSelected ? 'blue' : 'white',
                  '&:hover': {
                    backgroundColor: 'lightblue',  // Custom hover color for options
                  },
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  // height: 'auto',  // Ensure the indicators container adapts to the control height
                  // width: '30px'
                }),
              };

              if (schemaKey == 'Receivers') {
                if (isHostCompany == false) {
                  userInputField = React.createElement(
                    Select,
                    {
                      id: userIdValue,

                      styles: customStyles,
                      // className: `${styles.inputBoxStyleMultiSelectDropdown}`,
                      // style: {margin: '5px 0', height: '58px'},
                      'data-live-search': true,
                      title: `Select ${schemaKey}`,
                      placeholder: `Select ${schemaKey}`,
                      //  multiple: isMultiple,
                      //  mode: isMultiple ? 'multiple' : undefined,
                      styles: currentSchemaName == 'Users' ? nonEditableStyles : customStyles,
                      isMulti: true,
                      onChange: (e) => updateDropdownValue(e, schemaKey),
                      options: multiOptions,
                      defaultValue: selectedOptions
                    },
                  )
                }
                else if (isHostCompany == true) {
                  continue
                }
              } else {
                userInputField = React.createElement(Select, {
                  id: userIdValue,
                  // className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                  className: `${styles.inputBoxStyleMultiSelectDropdown}`,
                  // style: { padding: '0px' },
                  'data-live-search': true, title: `Select ${schemaKey}`, placeholder: schemaKey == 'Test Suites' ? `Select Test Suite(s)` : `Select ${schemaKey}`,

                  // multiple: isMultiple,
                  isMulti: true,
                  // value: queryDetail[schemaKey],
                  defaultValue: selectedOptions,
                  // defaultValue:resultData.filter(e=> e._id == queryDetail[schemaKey])  ,
                  onChange: (e) => updateDropdownValue(e, schemaKey),
                  options: multiOptions,
                  styles: currentSchemaName == 'Users' ? nonEditableStyles : customStyles,
                  // isReadOnly: schemaKey == 'Test Suites' && true, 
                  isDisabled: schemaKey == 'Test Suites' ? true : false,

                  // style: schemaKey == 'Test Suites' && { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' }
                },
                  [
                    // React.createElement(Option, {
                    //   value: 0, key: 'default',
                    //   id: 0,
                    //   // selected: true // hasValue && (isMultiple ? queryDetail[schemaKey].includes(id) : id === ele)
                    // },
                    //   'Please select...'),

                    // resultData.map((ele, index) => (
                    //   React.createElement(Option, {
                    //     key: ele._id,
                    //     value: ele._id,
                    //     //  selected: hasValue && (isMultiple ? queryDetail[schemaKey].includes(arr._id) : arr._id === ele)
                    //     selected: queryDetail[schemaKey].includes(ele._id)

                    //   }, ele.Name)
                    // ))
                  ]
                )
              }
            }

          }
          else {
            // userInputField = createTableComponent('select', { id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) });

            userInputField = createTableComponent('select', {
              id: userIdValue,
              className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
              'data-live-search': true,
              title: 'None',
              multiple: isMultiple,
              // defaultValue: queryDetail[schemaKey],
              onChange: (e) => updateValue(e, schemaKey),
              mode: isMultiple ? 'multiple' : undefined
            },
              [
                createTableComponent('option', {
                  value: 0, key: 'default',
                  id: 0,
                  selected: true // hasValue && (isMultiple ? queryDetail[schemaKey].includes(id) : id === ele)
                },
                  'Please select...'),
                resultData && resultData.map((arr, i) => (

                  createTableComponent('option', {
                    key: arr._id,
                    // id: arr._id,
                    value: arr._id,
                    // selected: queryDetail[schemaKey].includes(arr._id) //arr._id === ele
                  }, arr.Name
                  )
                ))
              ]
            )
          }
        }
        else if (attributeType == 'date') {
          if (hasValue) {
            userInputField = createTableComponent('DatePicker', { type: 'Date', id: userIdValue, value: formValues[schemaKey], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, disabled: isAttrEditable ? false : true, onChange: (e) => updateValue(e, schemaKey), schemaKey });
          }
          else {
            userInputField = createTableComponent('DatePicker', { type: 'Date', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, disabled: isAttrEditable ? false : true, onChange: (e) => updateValue(e, schemaKey), schemaKey });
          }
        }
        else
          if (attributeType === "array") {
            const companyId = formValues.Company || queryDetail.Company;
            let companyData = [];

            $.ajax({
              type: 'GET',
              url: `${ApiUrl.newUrl}/api/dbjsonschema/schema/Company/id/${companyId}`,
              async: false,
              dataType: 'json',
              headers: { jwt: localStorage.getItem("jwt") },
              success: function (result) {
                companyData = result.data?.company;
              },
              error: function (xhr, status, error) {
                console.error("Error fetching data:", status, error);
              }
            });

            if (currentSchemaName === "Users" && schemaKey === "Role") {

              const roleValue = Array.isArray(formValues.Role)
                ? formValues.Role
                : formValues.Role
                  ? formValues.Role.split(",").map(r => r.trim())
                  : [];

              const finalRoleOptions =
                companyData?.IsHostCompany === true
                  ? getFilteredRoleOptions(roleValue)
                  : externalRoleOptions;

              userInputField = (
                <Select
                  id={userIdValue}
                  styles={customStyles}
                  // className={styles.InputBoxStyle}
                  isMulti
                  options={finalRoleOptions}
                  value={roleValue.map(v => ({ value: v, label: v }))}
                  onChange={(selected) => {
                    const newValue = selected ? selected.map(opt => opt.value) : [];
                    setUserRole(newValue);
                    setFormValues((prev) => ({ ...prev, Role: newValue }));
                    setIsDirty(true);
                  }}
                  placeholder={`Select ${schemaKey}`}
                  isDisabled={
                    (userEditProfile === "userEditProfile" && schemaKey === "Role") ||
                    (
                      ["Admin", "Internal Admin", "Test Admin"].includes(session?.user?.roles?.[0]) &&
                      Array.isArray(queryDetail[schemaKey]) &&
                      queryDetail[schemaKey].includes("Admin")
                    )
                  }
                />
              );
            }
          }

          else if (attributeType == 'string') {


            if (schemaModel[schemaKey]['oneOf']) {
              userInputField = createTableComponent(
                'select',
                { id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, disabled: isAttrEditable ? false : true, onChange: (e) => updateValue(e, schemaKey) },
                schemaModel[schemaKey]['oneOf'].map((opt, i) => (
                  // <Option key={i} value={opt.title}>{opt.title}</Option>
                  createTableComponent('option', {
                    key: i,
                    value: opt.title,
                    selected: opt.title == queryDetail[schemaKey]
                  }, opt.title)
                ))
              );
            }
            else if (schemaModel[schemaKey]["isFile"]) {
              const fileName = queryDetail[schemaKey];
              const attributeName = schemaKey;

              const handleDownloadFile = (fileValue) => {
                if (!currentSchemaName || !currentItemID || !attributeName) {
                  message.error("Missing required parameters for file download");
                  return;
                }

                const files = Array.isArray(fileValue) ? fileValue : fileValue ? [fileValue] : [];
                const displayName = formValues?.Name || "Default";
                const baseUrl = ApiUrl.newUrl || window.location.origin;

                const url = `${baseUrl}/api/fetchUploadedFile/${encodeURIComponent(currentSchemaName)
                  }/${encodeURIComponent(currentItemID)}/${encodeURIComponent(attributeName)}/all?mode=download&displayName=${encodeURIComponent(displayName)}`;

                const link = document.createElement("a");
                link.href = url;
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              };


              const uploadField = React.createElement(
                Upload,
                {
                  accept: "*",
                  id: "btnUpload" + schemaKey,
                  multiple: true,
                  maxCount: undefined,
                  showUploadList: true,
                  onChange: (info) => {
                    if (info.fileList && info.fileList.length > 0) {
                      uploadedFilesRef.current[schemaKey] = info.fileList.map(f => f.originFileObj);

                      setUploadedFileNames((prev) => ({
                        ...prev,
                        [schemaKey]: info.fileList.map(f => f.name),
                      }));

                      // Clear old backend value
                      queryDetail[schemaKey] = undefined;

                      updateValue(
                        {
                          target: {
                            id: "btnUpload" + schemaKey,
                            type: "file",
                            value: info.fileList.map(f => f.name),
                          },
                        },
                        schemaKey
                      );
                    } else {
                      uploadedFilesRef.current[schemaKey] = [];
                      setUploadedFileNames((prev) => ({
                        ...prev,
                        [schemaKey]: [],
                      }));
                      queryDetail[schemaKey] = undefined;
                      updateValue(
                        {
                          target: {
                            id: "btnUpload" + schemaKey,
                            type: "file",
                            value: [],
                          },
                        },
                        schemaKey
                      );
                    }
                  },
                },
                React.createElement(
                  Button,
                  {
                    type: "primary",
                    icon: React.createElement(UploadOutlined),
                    style: { borderRadius: "6px" },
                  },
                  "Upload"
                )
              );

              const showDownloadIcon = !!fileName;

              userInputField = React.createElement(
                "div",
                {
                  className: styles.uploadWrapper,
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                    padding: "8px 12px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "8px",
                    backgroundColor: "#fafafa",
                  },
                },
                [
                  React.createElement(
                    "div",
                    {
                      key: "fileNameDisplay",
                      style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        maxWidth: "60%",
                      },
                    },
                    [
                      React.createElement(
                        "span",
                        {
                          style: {
                            fontWeight: 500,
                            color: "#333",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                          },
                          title: uploadedFileNames[schemaKey] || fileName || "No file uploaded",
                        },
                        uploadedFileNames[schemaKey] || fileName || "No file uploaded"
                      ),
                      showDownloadIcon &&
                      React.createElement(
                        Tooltip,
                        { title: "Download File" },
                        React.createElement(DownloadOutlined, {
                          style: {
                            color: "#1890ff",
                            fontSize: "18px",
                            cursor: "pointer",
                          },
                          onClick: handleDownloadFile,
                        })
                      ),
                    ]
                  ),
                  uploadField,
                ]
              );
            }

            else {
              if (hasValue) {
                {
                  schemaKey == 'Description' ? userInputField = createTableComponent('textarea', { rows: '2', id: userIdValue, type: 'text', value: queryDetail[schemaKey], placeholder: placeholder ? `${placeholderValue} Name` : '', disabled: isAttrEditable ? false : true, onChange: (e) => updateValue(e, schemaKey), className: `${styles.InputBoxStyle} ${styles.formcontrol}`, style: { marginBottom: '-14px' } })
                    : userInputField = createTableComponent('input', {
                      id: userIdValue, type: 'text', value: queryDetail[schemaKey], placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                      // disabled:userEditProfile == "userEditProfile" && (schemaKey == "Email" || schemaKey == "UserID") ? true:false,
                      //  style:  (userEditProfile == 'userEditProfile'  && (schemaKey == "Email" || schemaKey == "UserID") )? { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' } : {}
                      disabled: currentSchemaName == "Users" && (schemaKey == "Email" || schemaKey == "UserID") ? true : isAttrEditable ? false : true,
                      style: (currentSchemaName == "Users" && (schemaKey == "Email" || schemaKey == "UserID")) ? { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' } : {}
                    })
                }

              }
              else {
                if ([schemaKey] == 'XML File') {
                  userInputField = createTableComponent('input', { type: 'text', id: userIdValue, value: xmlAndBatch['XML File'], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey) });

                }
                else if ([schemaKey] == 'Batch File') {
                  userInputField = createTableComponent('input', { type: 'text', id: userIdValue, value: xmlAndBatch['Batch File'], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey) });
                }
                else {
                  {
                    schemaKey == 'Description' ? userInputField = createTableComponent('textarea', { rows: '2', id: userIdValue, type: 'text', placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), className: `${styles.InputBoxStyle} ${styles.formcontrol}`, style: { marginBottom: '-14px' } })
                      :
                      userInputField = createTableComponent('input', { type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey) });
                  }

                }
              }
            }

            // if (schemaModel[schemaKey]['oneOf']) {
            //     let opt = schemaModel[schemaKey]['oneOf']
            //     userInputField = createComponent('select', '', '', userIdValue, 'InputBoxStyle formcontrol');
            //     $.each(opt, function (i, selVal) {
            //         let selopt = createTableComponent('option');
            //         selopt.value = selVal.title;
            //         $(selopt).text(selVal.title);
            //         if (hasValue) {
            //             if (selVal.title == queryDetail[schemaKey])
            //                 $(selopt).attr('selected', true);
            //         }
            //         userInputField.appendChild(selopt);
            //     });
            // } else {
            //     if (hasValue) {
            //         userInputField = createTableComponent('input', 'text', queryDetail[schemaKey], userIdValue, 'InputBoxStyle formcontrol')

            //     } else {
            //         userInputField = createTableComponent('input', 'text', '', userIdValue, 'InputBoxStyle formcontrol')

            //     }
            //     if (schemaModel[schemaKey].hasOwnProperty("tooltip") && schemaModel[schemaKey].Tooltip != "") {
            //         $(userInputField).attr('title', schemaModel[schemaKey].tooltip);
            //     } else {
            //         $(userInputField).attr('title', attributeType);
            //     }
            // }
          }

        if (userInputField) {

          if (currentSchemaName == 'TestSuite' && schemaKey == 'Package') {
            // console.log('inside')


            userInputField = React.createElement('input', {
              type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true, placeholder: 'Select Package Zip File',
              //  value: packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name'], 
              // value: formValues && formValues.Package || '',
              // value: formValues && formValues['Package'] && formValues['Package'][0]['fileList'][0] && formValues['Package'][0]['fileList'][0]['File Name']
              // value: fileNameStore,
              value: packageFileName
            },
            )


            const deleteButton = (
              <Button onClick={() => handleFileRemove(schemaKey)} style={{ cursor: 'pointer' }}
                type='ghost'>Delete
              </Button>
            )
            attribute.push(
              <>
                <div key={idValue} id={idValue} className={`${schemaKey == 'Is Performance?' ? styles.formRowIsPerformance : styles.formRow}`} //className="form-row form-group"
                >
                  {label}
                  {userInputField}

                </div>
                <span style={{
                  marginTop: '50px',
                  // float: 'right', 
                  marginRight: '-18px'
                }}>
                  {/* {
                    // packages[0]['fileList'][0]
                    packageFileName != ''
                      ?
                      deleteButton
                      :
                      <Upload
                        {...mainUploadProps}
                        disabled={packages[0]['fileList'].length != 0}
                      >
                        <Button type="primary">Browse</Button>
                      </Upload>} */}

                  {
                    <Upload
                      {...mainUploadProps}
                    // disabled={packages[0]['fileList'].length != 0}
                    >
                      <Button type="primary">Update</Button>
                    </Upload>}
                </span>
              </>
            );




            // // userInputField = createTableComponent('input', { type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true, value: packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name'] });
            // userInputField = React.createElement('input', {
            //   type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true,
            //   value: packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name'],
            //   // value: formValues && formValues.Package, 
            //   //  onChange: (e)=> updateValue(e, schemaKey), 
            //   // value: uploadedFiles[schemaKey]?.name || '', 
            // },
            // )

            // const removeButton = packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name']// uploadedFiles[schemaKey]
            //   ? React.createElement(DeleteOutlined, {
            //     onClick: () => handleFileRemove(schemaKey),
            //     style: {
            //       cursor: 'pointer', marginRight: '-15px'
            //       // marginLeft: 8 
            //     },
            //     key: `${schemaKey}-remove-button`,
            //   })
            //   : null;


            // const uploadButton = React.createElement(Upload, {
            //   beforeUpload: (file) => handleFileUpload(file, schemaKey),
            //   multiple: false,
            //   showUploadList: false,
            //   key: `${schemaKey}-upload-button`,
            // }, React.createElement(Button, { icon: <UploadOutlined /> }, 'Browse'));

            // attribute.push(
            //   <>
            //     <div key={idValue} id={idValue} className={`${schemaKey == 'Is Performance?' ? styles.formRowIsPerformance : styles.formRow}`} //className="form-row form-group"
            //     >
            //       {label}

            //       {/* <input type="text" readOnly value={ ''} className={`${styles.InputBoxStyle} ${styles.formcontrol}`} /> */}

            //       {userInputField}
            //       {removeButton}
            //     </div>
            //     <span style={{ marginTop: '-36px', float: 'right', marginRight: '-18px' }}>
            //       {<Upload
            //         {...mainUploadProps}
            //         disabled={packages[0]['fileList'].length != 0}  >
            //         <Button type="primary">Browse</Button>
            //       </Upload>}
            //     </span>
            //   </>
            // );
          }
          else {
            attribute.push(
              <div key={idValue} id={idValue} className={styles.formRow} //className="form-row form-group"
              >
                {label}
                {userInputField}
                <div className="help-block with-errors"></div>
              </div>
            )
          }
        }


        // console.log('userInputField 2: ', userInputField )

      }
      // setFormItems(items)

      // console.log('items: ',items)

      // return null;
    }

    // )
  };

  const LoadEditContent = (schemaModel, queryDetail, formAttribute, reloadValue = null) => {
    let items = []

    const schemaMap = schemaModel && Object.keys(schemaModel).map(k => ({ id: k, ...schemaModel[k] }));
    // console.log('schemaMap: ', schemaMap)
    // const sortedData = schemaMap.sort((a, b) => a.editable - b.editable);
    const filteredEditable = schemaMap.filter(a => a.visible === true);
    // const filteredNonEditable = sortedData.filter(a => a.editable === false);
    let attribute = []
    // useEffect(() => {
    // Process the editable content
    ProcessEditContent(schemaModel, queryDetail, formAttribute, filteredEditable, attribute, reloadValue);

    // Create and append accordion panel for non-editable content
    // const divAccordionPanel = createTableComponent('div', '', '', '', 'accordionPanel');
    const divAccordionPanel = createTableComponent('div', { type: '', id: '', className: 'accordionPanel' });

    // const divPanel = createTableComponent('div', '', '', '');
    const divPanel = createTableComponent('div', { type: '', id: '', className: '' });
    // divPanel.innerHTML = '<div class="panel-heading"><div class="panel-title"><a class="collapsed" data-toggle="collapse"  href="#fieldsSec"><span>&nbsp;</span></a></div></div>';

    // divAccordionPanel.appendChild(divPanel);

    // const hiddenFieldDiv = createTableComponent('div', '', '', 'fieldsSec', 'panel-collapse collapse');
    const hiddenFieldDiv = createTableComponent('div', { type: '', id: 'fieldsSec', className: 'panel-collapse collapse' });
    // ProcessEditContent( schemaModel, queryDetail,  hiddenFieldDiv, filteredNonEditable, attribute );
    // divAccordionPanel.appendChild(hiddenFieldDiv);
    // formAttribute.appendChild(divAccordionPanel);
    items.push(divAccordionPanel)
    // setFormItems(divAccordionPanel)
    // }, [schemaModel, queryDetail, formAttribute, filteredEditable, filteredNonEditable]);
    setFormItems(attribute)
    // return null;
  };


  const ProcessViewContent = (schemaModel, queryDetail, formAttribute, filteredData, attribute, isViewOnly = false, currentHostCompany) => {
    // const [jsonData, setJsonData] = useState({});
    // console.log(queryDetail)
    let items = []
    // formAttribute = []
    // const [formValue, setFormValue] = useState(queryDetail)
    let formValue = {};

    let xmlAndBatch = {}

    // useEffect(() => {
    const arrayToString = JSON.stringify(Object.assign({}, filteredData));
    const stringToJsonObject = JSON.parse(arrayToString);
    const tempJsonData = {};

    for (let key in stringToJsonObject) {
      const d = stringToJsonObject[key];
      const columnName = stringToJsonObject[key].id;
      delete d["id"];
      tempJsonData[columnName] = d;
    }
    // setJsonData(tempJsonData);
    jsonData = tempJsonData
    // }, [filteredData]);

    if (currentSchemaName == 'TestSuite') {
      if (schemaModel['Package']['ref'] == "Package") {

        let reference = schemaModel['Package']['ref'];
        // let propVal = queryDetail[schemaKey];
        // let strPropVal = Array.isArray(propVal) ? propVal.join() : propVal;
        // let packageId = queryDetail['Package']
        let pkgId = Array.isArray(queryDetail['Package']) ? queryDetail['Package'][0] : queryDetail['Package'];


        $.ajax({
          type: 'GET',
          url: ApiUrl.newUrl + '/api/dbjsonschema/getPackageInfo/' + reference + '/' + pkgId,
          dataType: 'json',
          async: false,
          headers: { jwt: localStorage.getItem("jwt") },
          success: function (result) {
            console.log("Sucessfully fetched package info");
            if (result) {

              // fileList[0]['File Name']
              let packageFileId = Array.isArray(result.data[0]['PackageFile']) ? result.data[0]['PackageFile'].shift() : result.data[0]['PackageFile'];

              if (result.data[0]['PackageFile']) {
                $.ajax({
                  type: 'GET',
                  url: ApiUrl.newUrl + '/api/dbjsonschema/getPackageInfo/' + 'PackageFile' + '/' + packageFileId,
                  dataType: 'json',
                  async: false,
                  headers: { jwt: localStorage.getItem("jwt") },
                  success: function (result1) {
                    console.log('Successfully fetched package file details');
                    // result && setDataSource(result.data)

                    if (result1) {
                      setPackages([{
                        packageId: 1,
                        fileList: result1.data,
                      }])
                      setFileNameStore(result1.data[0]['File Name'])
                      packageFileName = result1.data[0]['File Name']
                      setShowFileList(true);
                    }
                  },
                  error: function (xhr, status, error) {
                    console.error("Error fetching package file details:", status, error);
                  }

                });

              }

              xmlAndBatch = {
                'Batch File': result.data[0]['Batch File'],
                'XML File': result.data[0]['XML File']
              }

              // setFormValues(xmlAndBatch)

            }

            // tempStorage[reference.toLowerCase()] = result.data[reference.toLowerCase()]
            // resultData = result.data[reference.toLowerCase()];
          },
          error: function (xhr, status, error) {
            console.error("Error fetching package info:", status, error);
          }

        });

      }

    }





    const sortedKeysView = Object.keys(tempJsonData);
    const keyIndexMapView = Object.fromEntries(sortedKeysView.map((k, i) => [k, i]));

    sortedKeysView.sort((a, b) => {
      const orderA = schemaModel[a].order !== undefined ? Number(schemaModel[a].order) : Infinity;
      const orderB = schemaModel[b].order !== undefined ? Number(schemaModel[b].order) : Infinity;

      if (orderA !== Infinity && orderB !== Infinity) {
        return orderA - orderB;
      } else if (orderA === Infinity && orderB === Infinity) {
        return keyIndexMapView[a] - keyIndexMapView[b];
      } else {
        return orderA - orderB;
      }
    });

    for (let schemaKey of sortedKeysView) {

      if ([schemaKey] == 'Batch File') {
        setFormValues((prev) => ({
          ...prev,
          [schemaKey]: xmlAndBatch['Batch File'],
        }))
      } else if ([schemaKey] == 'XML File') {
        setFormValues((prev) => ({
          ...prev,
          [schemaKey]: xmlAndBatch['XML File'],
        }))
      }
      else {
        setFormValues((prev) => ({
          ...prev,
          [schemaKey]: queryDetail[schemaKey]
          // [schemaKey]: schemaKey == 'Test Suites'? queryDetail['TestSuiteRun'] : queryDetail[schemaKey],
        }))
      }



      let listItem;

      const hasValue = queryDetail.hasOwnProperty(schemaKey);
      // console.log(schemaKey)
      // console.log(queryDetail[schemaKey])
      let canDisplay = schemaModel[schemaKey].hasOwnProperty("visible") ? schemaModel[schemaKey].visible : true;

      if (schemaKey === "Approval Required" && isHostCompany) canDisplay = false;
      if (schemaKey === "Approvers" && !isHostCompany) canDisplay = false;
      if (schemaKey === "Reviewers" && !isHostCompany) canDisplay = false;

      if (canDisplay) {
        let isMultiple = false
        let attributeType = ""
        if (Array.isArray(schemaModel[schemaKey]['type'])) {
          attributeType = schemaModel[schemaKey]['type'][0].toLowerCase()
          isMultiple = true
        } else {
          attributeType = schemaModel[schemaKey]['type'].toLowerCase();
        }
        const isAttrEditable = schemaModel[schemaKey]['editable'];
        const idValue = 'detailField_' + attributeType;
        const userIdValue = 'detailAttr_' + schemaKey;

        const placeholder = schemaModel[schemaKey]['placeHolder']
        const placeholderValue = 'Enter ' + schemaKey




        // const commonProps = {
        //     id: userIdValue,
        //     className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
        //     id: schemaKey,
        //     value: queryDetail[schemaKey] || '',
        //     onChange: (e) => updateValue(e, schemaKey)
        // };

        // listItem = createComponent('li', { type: '', id: idValue, className: 'form-row form-group'});
        listItem = createTableComponent('li', { type: '', id: idValue, className: 'form-row form-group' });

        // const label = createTableComponent('label', '', schemaKey.charAt(0).toUpperCase() + schemaKey.slice(1), '', 'control-label');
        // const label = 
        //    let label = createComponent('label', {type: '', value: schemaKey.charAt(0).toUpperCase() + schemaKey.slice(1), id: '', className: 'control-label'} );
        let labelText = schemaModel[schemaKey].hasOwnProperty("displayName") && schemaModel[schemaKey].displayName
          ? schemaModel[schemaKey].displayName
          : schemaKey;

        // Check for special case
        if (currentSchemaName === 'Approval') {
          if (labelText === 'Job Name') {
            labelText = 'Job Title';
          }
        }

        // Create label normally
        let label = createTableComponent('label', {
          className: styles['control-label'],
          value: labelText.charAt(0).toUpperCase() + labelText.slice(1)
        });

        // Append * for required fields or specific keys
        if (schemaModel[schemaKey].required || schemaKey === 'Approvers' || schemaKey === 'Reviewers') {
          label = (
            <>
              {label}
              <span className={styles.reqField}>*</span>
            </>
          );
        }
        // if (schemaModel[schemaKey].hasOwnProperty("required") && schemaModel[schemaKey].required) {
        //     // const spanReq = createTableComponent('span', '', '*', '', 'reqField');
        //     // const spanReq = 
        //    listItem = createTableComponent('span',{type: '',value:'*', id: '', className:`${styles.reqField}` });

        //     // label.appendChild(spanReq);
        // }


        // listItem.appendChild(label);

        let userInputField;
        // Logic for creating userInputField based on attributeType...
        // Replace your jQuery manipulations with appropriate React code

        if (attributeType == 'boolean') {

          // userInputField = createTableComponent('input', { id: userIdValue, type: 'checkbox', className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true })
          userInputField = React.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(
              'label',
              { style: { marginRight: '10px', display: 'flex' } },
              React.createElement('input', {
                type: 'radio',
                id: userIdValue + 'true',
                name: schemaKey,
                // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                //  defaultChecked: formValues && formValues[schemaKey] == true,
                defaultChecked: queryDetail[schemaKey] == true,
                value: true,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                style: { marginRight: '5px' },
                onChange: (e) => updateValue(e, schemaKey),
                disabled: true
              }),
              'Yes'
            ),
            React.createElement(
              'label',
              { style: { marginRight: '10px', display: 'flex' } },
              React.createElement('input', {
                type: 'radio',
                id: userIdValue + 'false',
                name: schemaKey,
                // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                // checked: true,
                // defaultChecked: formValues && formValues[schemaKey] != true,
                defaultChecked: queryDetail[schemaKey] == false,
                // defaultChecked: true,
                value: false,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                style: { marginRight: '5px' },
                onChange: (e) => updateValue(e, schemaKey),
                disabled: true
              }),
              'No'
            )
          );
          if (hasValue) {
            let isChecked = queryDetail[schemaKey]
            // if (isChecked) {

            if (schemaKey == 'Is Performance?') {
              userInputField = React.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(
                  'label',
                  { style: { marginRight: '10px', display: 'flex' } },
                  React.createElement('input', {
                    type: 'radio',
                    id: userIdValue + 'true',
                    name: schemaKey,
                    // checked: formValues && formValues[schemaKey] === true,  //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] === true,
                    //  defaultChecked: formValues && formValues[schemaKey] == true,
                    defaultChecked: queryDetail[schemaKey] == true,
                    value: true,
                    className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                    style: { marginRight: '5px' },
                    onChange: (e) => updateValue(e, schemaKey),
                    disabled: true
                  }),
                  'Yes'
                ),
                React.createElement(
                  'label',
                  { style: { marginRight: '10px', display: 'flex' } },
                  React.createElement('input', {
                    type: 'radio',
                    id: userIdValue + 'false',
                    name: schemaKey,
                    // checked: formValues && formValues[schemaKey] !== true, //formValues.hasOwnProperty(schemaKey) && formValues[schemaKey] !== true, // formValues[schemaKey] != true,
                    // checked: true,
                    // defaultChecked: formValues && formValues[schemaKey] != true,
                    defaultChecked: queryDetail[schemaKey] == false,
                    // defaultChecked: true,
                    value: false,
                    className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                    style: { marginRight: '5px' },
                    onChange: (e) => updateValue(e, schemaKey),
                    disabled: true
                  }),
                  'No'
                )
              );
            }
            // else {
            //   // userInputField = createTableComponent('input', { id: userIdValue, type: 'checkbox', className: `${styles.InputBoxStyle} ${styles.formcontrol}`, value: 'checked', onChange: (e) => updateValue(e, schemaKey), readOnly: true })

            // }
            // }
          }

        }
        else if (attributeType == 'number') {
          if (schemaModel[schemaKey]['oneOf']) {

            userInputField = createTableComponent(
              'select',
              {
                id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey),
                // readOnly: true, 
                disabled: true,
                // style: { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' }
              },
              schemaModel[schemaKey]['oneOf'].map((opt, i) => (
                // <Option key={i} value={opt.title}>{opt.title}</Option>
                createTableComponent('option', {
                  key: opt.enum,
                  value: opt.enum,
                  selected: opt.enum == queryDetail[schemaKey]
                }, opt.title)
              ))
            );


          } else {
            if (hasValue) {
              userInputField = createTableComponent('input', { type: 'number', id: userIdValue, value: queryDetail[schemaKey], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true });
              // userInputField = createTableComponent('input', 'number', queryDetail[schemaKey],userIdValue, `${styles.InputBoxStyle} ${styles.formcontrol}` )

            }
            else {
              userInputField = createTableComponent('input', { type: 'number', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true });
              // userInputField = createTableComponent('input', 'number', '', userIdValue, `${styles.InputBoxStyle} ${styles.formcontrol}` );

            }
          }

        }
        else if (attributeType.toLowerCase() == 'objectid') {

          let options = "";
          let resultData;
          let refOpt;
          let reference = schemaModel[schemaKey]['ref'];
          let propVal = queryDetail[schemaKey];
          let strPropVal = Array.isArray(propVal) ? propVal.join() : propVal;

          let ajaxUrl = isAttrEditable ? '/api/dbjsonschema/schema/' + reference :
            '/api/dbjsonschema/schema/' + reference + '/id/' + strPropVal;

          if (reference && !tempStorage.hasOwnProperty(reference.toLowerCase())) {
            $.ajax({
              type: 'GET',
              url: ApiUrl.newUrl + ajaxUrl,
              dataType: 'json',
              async: false,
              headers: { jwt: localStorage.getItem("jwt") },
              success: function (result) {
                tempStorage[reference.toLowerCase()] = result.data[reference.toLowerCase()]
                resultData = result.data[reference.toLowerCase()];
              },
              error: function (xhr, status, error) {
                console.error("Error fetching data:", status, error);
              }

            });
          }
          else if (tempStorage.hasOwnProperty(reference.toLowerCase())) {
            resultData = tempStorage[reference.toLowerCase()];
          }

          if (resultData != undefined) {
            resultData = Array.isArray(resultData) ? resultData : [resultData];
          }

          if (hasValue) {

            if (!isMultiple) {
              // Array.isArray(queryDetail[schemaKey]) && queryDetail[schemaKey].map((ele, index) => (
              userInputField = createTableComponent('select', {
                id: userIdValue,
                // className: 'formcontrol refObj show-tick',
                // className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
                className: `${styles.InputBoxStyle} ${styles.formcontrol}`,
                'data-live-search': true,
                // type: '',
                title: 'None',
                multiple: isMultiple,
                // value: ele,
                defaultValue: queryDetail[schemaKey],
                onChange: (e) => updateValue(e, schemaKey),
                mode: isMultiple ? 'multiple' : undefined,
                readOnly: true,
                disabled: true,
                // style: { backgroundColor: '#f0f0f0', color: '#777', cursor: 'not-allowed' }
              },
                [
                  createTableComponent('option', {
                    value: "", key: 'default',

                    hidden: true,
                    disabled: true
                  },
                    'Please select...'),
                  //  ...resultData.map((arr, i)=>(
                  //    Array.isArray(queryDetail[schemaKey]) && queryDetail[schemaKey].map((ele, index)=>(
                  resultData && resultData.map((arr, i) => (
                    // if (ele == arr._id) {
                    // userInputField = 
                    // console.log('arr: ',arr)
                    // ele == arr._id ? 
                    createTableComponent('option', {
                      key: arr._id,
                      // id: arr._id,
                      value: arr._id,
                      selected: queryDetail[schemaKey].includes(arr._id)
                    }, arr.Name
                    )
                    // :''

                  ))
                  //  ))
                ]
              )
              // )
              // )

            }
            else {
              const multiOptions = resultData.map((ref) => ({
                value: ref._id,
                label: ref.Name,
              }));

              const selectedOptions = []
              resultData.filter((option) => {
                if (queryDetail[schemaKey].includes(option._id)) {
                  selectedOptions.push({
                    value: option._id,
                    label: option.Name,
                  })
                }

              })
              // console.log(selectedOptions)

              const nonEditableStyles = {
                control: (provided) => ({
                  ...provided,
                  margin: '5px 0px',
                  minHeight: '50px',
                  // readOnly: true,
                  // isDisabled: true,
                  backgroundColor: 'white',
                  '&:hover': {
                    borderColor: 'darkblue',
                  },
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  // height: '50px',  // Match the control height for consistent padding
                  padding: '10px 16px',  // Adjust padding inside the input field
                }),
                input: (provided) => ({
                  ...provided,
                  margin: '0px',  // Remove default margin
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,  // Ensure dropdown appears above other elements
                }),
                option: (provided, state) => ({
                  ...provided,
                  color: state.isSelected ? 'white' : 'black',
                  backgroundColor: state.isSelected ? 'blue' : 'white',
                  '&:hover': {
                    backgroundColor: 'lightblue',  // Custom hover color for options
                  },
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  // height: 'auto',  // Ensure the indicators container adapts to the control height
                  // width: '30px'
                }),
              };

              if (schemaKey === "Receivers") {
                if (currentHostCompany === false) {
                  userInputField = React.createElement(Select, {
                    id: userIdValue,
                    styles: customStyles,
                    'data-live-search': true,
                    title: `Select ${schemaKey}`,
                    placeholder: schemaKey === 'Test Suites' ? "Select Test Suite(s)" : `Select ${schemaKey}`,
                    isMulti: true,
                    onChange: (e) => updateDropdownValue(e, schemaKey),
                    options: multiOptions,
                    defaultValue: selectedOptions,
                    styles: nonEditableStyles,
                    isDisabled: true,
                  });
                } else if (currentHostCompany === true) {
                  continue
                }
              } else {
                // All other schemaKeys → unaffected
                userInputField = React.createElement(Select, {
                  id: userIdValue,
                  className: `${styles.inputBoxStyleMultiSelectDropdown}`,
                  'data-live-search': true,
                  title: `Select ${schemaKey}`,
                  placeholder: schemaKey === 'Test Suites' ? "Select Test Suite(s)" : `Select ${schemaKey}`,
                  isMulti: true,
                  defaultValue: selectedOptions,
                  onChange: (e) => updateDropdownValue(e, schemaKey),
                  options: multiOptions,
                  styles: nonEditableStyles,
                  isDisabled: true,
                });
              }

            }

          }
          else {
            // userInputField = createTableComponent('select', { id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey) });

            userInputField = createTableComponent('select', {
              id: userIdValue,
              className: `${styles.formcontrol} ${styles.refObj} ${styles['show-tick']}`,
              'data-live-search': true,
              title: 'None',
              multiple: isMultiple,
              // defaultValue: queryDetail[schemaKey],
              onChange: (e) => updateValue(e, schemaKey),
              mode: isMultiple ? 'multiple' : undefined,
              readOnly: true,
              disabled: true
            },
              [
                createTableComponent('option', {
                  value: 0, key: 'default',
                  id: 0,
                  selected: true // hasValue && (isMultiple ? queryDetail[schemaKey].includes(id) : id === ele)
                },
                  'Please select...'),
                resultData && resultData.map((arr, i) => (

                  createTableComponent('option', {
                    key: arr._id,
                    // id: arr._id,
                    value: arr._id,
                    // selected: queryDetail[schemaKey].includes(arr._id) //arr._id === ele
                  }, arr.Name
                  )
                ))
              ]
            )
          }
        }
        else if (attributeType == 'date') {
          if (hasValue) {
            userInputField = createTableComponent('input', { type: 'text', id: userIdValue, value: queryDetail[schemaKey], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, 'data-toggle': 'datepicker', onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true });
          }
          else {
            userInputField = createTableComponent('input', { type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, 'data-toggle': 'datepicker', onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true });
          }
        }
        else if (attributeType == 'array') {
          if (hasValue) {
            userInputField = createTableComponent('input', { type: 'text', id: userIdValue, value: queryDetail[schemaKey], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true });
          }
          else {
            userInputField = createTableComponent('input', { type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true });
          }
        }
        else if (attributeType == 'string') {


          if (schemaModel[schemaKey]['oneOf']) {
            userInputField = createTableComponent(
              'select',
              { id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true },
              schemaModel[schemaKey]['oneOf'].map((opt, i) => (
                // <Option key={i} value={opt.title}>{opt.title}</Option>
                createTableComponent('option', {
                  key: i,
                  value: opt.title,
                  selected: opt.title == queryDetail[schemaKey]
                }, opt.title)
              ))
            );
          }
          else if (schemaModel[schemaKey]["isFile"]) {
            const fileValue = queryDetail[schemaKey];
            const attributeName = schemaKey;

            const baseUrl = ApiUrl.newUrl || window.location.origin;

            const files = Array.isArray(fileValue)
              ? fileValue
              : fileValue
                ? [fileValue]
                : [];
            const hasMultiple = files.length > 1;
            const singleFileName = files.length === 1 ? files[0] : null;

            const handleDownloadFile = () => {
              if (!currentSchemaName || !currentItemID || !attributeName) {
                message.error("Missing required parameters for file download");
                return;
              }

              const fileName = queryDetail?.Name || currentItemID;
              const url = `${baseUrl}/api/fetchUploadedFile/${currentSchemaName}/${currentItemID}/${attributeName}/all?mode=download&displayName=${encodeURIComponent(fileName)}`;


              const downloadName = hasMultiple
                ? `${attributeName}.zip`
                : singleFileName;

              const link = document.createElement("a");
              link.href = url;
              link.download = downloadName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            };

            const handleViewFile = () => {
              if (!singleFileName || !currentSchemaName || !currentItemID || !attributeName) {
                message.error("Missing required parameters for file view");
                return;
              }

              const url = `${baseUrl}/api/fetchUploadedFile/${encodeURIComponent(
                currentSchemaName
              )}/${encodeURIComponent(currentItemID)}/${encodeURIComponent(
                attributeName
              )}/${encodeURIComponent(singleFileName)}?mode=view`;

              const width = 1000;
              const height = 600;
              const left = window.screenX + (window.outerWidth - width) / 2;
              const top = window.screenY + (window.outerHeight - height) / 2;

              window.open(url, "_blank", `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`);
            };

            userInputField = React.createElement(
              "div",
              {
                className: styles.downloadWrapper,
              },
              [
                React.createElement(
                  "span",
                  {
                    className: files.length
                      ? styles.fileNameText
                      : `${styles.fileNameText} ${styles.noFile}`,
                  },
                  hasMultiple
                    ? `${files.length} files uploaded`
                    : singleFileName || "No file uploaded"
                ),
                !hasMultiple &&
                singleFileName &&
                React.createElement(
                  "span",
                  {
                    onClick: handleViewFile,
                    title: "Click to view",
                    role: "button",
                    className: styles.downloadIconWrapper,
                    style: { marginRight: 8 },
                    onMouseEnter: (e) => (e.target.style.color = "#52c41a"),
                    onMouseLeave: (e) => (e.target.style.color = "#1890ff"),
                  },
                  React.createElement(EyeOutlined, { className: styles.downloadIcon })
                ),
                files.length > 0 &&
                React.createElement(
                  "span",
                  {
                    onClick: handleDownloadFile,
                    title: "Click to download",
                    role: "button",
                    className: styles.downloadIconWrapper,
                    onMouseEnter: (e) => (e.target.style.color = "#40a9ff"),
                    onMouseLeave: (e) => (e.target.style.color = "#1890ff"),
                  },
                  React.createElement(DownloadOutlined, { className: styles.downloadIcon })
                ),
              ]
            );
          }

          else {
            if (hasValue) {
              {
                schemaKey == 'Description' ? userInputField = createTableComponent('textarea', { rows: '2', id: userIdValue, type: 'text', value: queryDetail[schemaKey], placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), className: `${styles.InputBoxStyle} ${styles.formcontrol}`, style: { marginBottom: '-14px' }, readOnly: true, disabled: true })
                  : userInputField = createTableComponent('input', { id: userIdValue, type: 'text', value: queryDetail[schemaKey], placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true, disabled: true })
              }

            }
            else {
              if ([schemaKey] == 'XML File') {
                userInputField = createTableComponent('input', { type: 'text', id: userIdValue, value: xmlAndBatch['XML File'], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), disabled: true });

              }
              else if ([schemaKey] == 'Batch File') {
                userInputField = createTableComponent('input', { type: 'text', id: userIdValue, value: xmlAndBatch['Batch File'], className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), disabled: true });
              }
              else {
                {
                  schemaKey == 'Description' ? userInputField = createTableComponent('textarea', { rows: '2', id: userIdValue, type: 'text', placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), className: `${styles.InputBoxStyle} ${styles.formcontrol}`, style: { marginBottom: '-14px' }, readOnly: true, disabled: true })
                    :
                    userInputField = createTableComponent('input', { type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, placeholder: placeholder ? `${placeholderValue} Name` : '', onChange: (e) => updateValue(e, schemaKey), readOnly: true, disabled: true });
                }

              }
            }
          }

          // if (schemaModel[schemaKey]['oneOf']) {
          //     let opt = schemaModel[schemaKey]['oneOf']
          //     userInputField = createComponent('select', '', '', userIdValue, 'InputBoxStyle formcontrol');
          //     $.each(opt, function (i, selVal) {
          //         let selopt = createTableComponent('option');
          //         selopt.value = selVal.title;
          //         $(selopt).text(selVal.title);
          //         if (hasValue) {
          //             if (selVal.title == queryDetail[schemaKey])
          //                 $(selopt).attr('selected', true);
          //         }
          //         userInputField.appendChild(selopt);
          //     });
          // } else {
          //     if (hasValue) {
          //         userInputField = createTableComponent('input', 'text', queryDetail[schemaKey], userIdValue, 'InputBoxStyle formcontrol')

          //     } else {
          //         userInputField = createTableComponent('input', 'text', '', userIdValue, 'InputBoxStyle formcontrol')

          //     }
          //     if (schemaModel[schemaKey].hasOwnProperty("tooltip") && schemaModel[schemaKey].Tooltip != "") {
          //         $(userInputField).attr('title', schemaModel[schemaKey].tooltip);
          //     } else {
          //         $(userInputField).attr('title', attributeType);
          //     }
          // }
        }

        if (userInputField) {

          if (currentSchemaName == 'TestSuite' && schemaKey == 'Package') {
            // console.log('inside')


            userInputField = React.createElement('input', {
              type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true, placeholder: 'Select Package Zip File',
              value: packageFileName, disabled: true
            },
            )


            const deleteButton = (
              <Button onClick={() => handleFileRemove(schemaKey)} style={{ cursor: 'pointer' }}
                type='ghost'>Delete
              </Button>
            )
            attribute.push(
              <>
                <div key={idValue} id={idValue} className={`${schemaKey == 'Is Performance?' ? styles.formRowIsPerformance : styles.formRow}`} //className="form-row form-group"
                >
                  {label}
                  {userInputField}

                </div>
                <span style={{
                  marginTop: '50px',
                  // float: 'right', 
                  marginRight: '-18px'
                }}>
                  {/* {
                    // packages[0]['fileList'][0]
                    packageFileName != ''
                      ?
                      deleteButton
                      :
                      <Upload
                        {...mainUploadProps}
                        disabled={packages[0]['fileList'].length != 0}
                      >
                        <Button type="primary">Browse</Button>
                      </Upload>} */}

                  {/* {
                    <Upload
                      {...mainUploadProps}
                    >
                      <Button type="primary">Update</Button>
                    </Upload>} */}
                </span>
              </>
            );




            // // userInputField = createTableComponent('input', { type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true, value: packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name'] });
            // userInputField = React.createElement('input', {
            //   type: 'text', id: userIdValue, className: `${styles.InputBoxStyle} ${styles.formcontrol}`, readOnly: true,
            //   value: packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name'],
            //   // value: formValues && formValues.Package, 
            //   //  onChange: (e)=> updateValue(e, schemaKey), 
            //   // value: uploadedFiles[schemaKey]?.name || '', 
            // },
            // )

            // const removeButton = packages[0]['fileList'][0] && packages[0]['fileList'][0]['File Name']// uploadedFiles[schemaKey]
            //   ? React.createElement(DeleteOutlined, {
            //     onClick: () => handleFileRemove(schemaKey),
            //     style: {
            //       cursor: 'pointer', marginRight: '-15px'
            //       // marginLeft: 8 
            //     },
            //     key: `${schemaKey}-remove-button`,
            //   })
            //   : null;


            // const uploadButton = React.createElement(Upload, {
            //   beforeUpload: (file) => handleFileUpload(file, schemaKey),
            //   multiple: false,
            //   showUploadList: false,
            //   key: `${schemaKey}-upload-button`,
            // }, React.createElement(Button, { icon: <UploadOutlined /> }, 'Browse'));

            // attribute.push(
            //   <>
            //     <div key={idValue} id={idValue} className={`${schemaKey == 'Is Performance?' ? styles.formRowIsPerformance : styles.formRow}`} //className="form-row form-group"
            //     >
            //       {label}

            //       {/* <input type="text" readOnly value={ ''} className={`${styles.InputBoxStyle} ${styles.formcontrol}`} /> */}

            //       {userInputField}
            //       {removeButton}
            //     </div>
            //     <span style={{ marginTop: '-36px', float: 'right', marginRight: '-18px' }}>
            //       {<Upload
            //         {...mainUploadProps}
            //         disabled={packages[0]['fileList'].length != 0}  >
            //         <Button type="primary">Browse</Button>
            //       </Upload>}
            //     </span>
            //   </>
            // );
          }
          else {
            attribute.push(
              <div key={idValue} id={idValue} className={styles.formRow} //className="form-row form-group"
              >
                {label}
                {userInputField}
                <div className="help-block with-errors"></div>
              </div>
            )
          }
        }


        // console.log('userInputField 2: ', userInputField )

      }
      // setFormItems(items)

      // console.log('items: ',items)

      // return null;
    }

    // )
  };

  const LoadViewContent = (schemaModel, queryDetail, formAttribute, colSetting, currentHostCompany) => {
    let items = []

    const schemaMap = schemaModel && Object.keys(schemaModel).map(k => ({ id: k, ...schemaModel[k] }));
    // console.log('schemaMap: ', schemaMap)
    const sortedData = schemaMap.sort((a, b) => a.editable - b.editable);
    const filteredEditable = sortedData.filter(a => a.editable === true);
    const filteredNonEditable = sortedData.filter(a => a.editable === false);
    let attribute = []
    // useEffect(() => {
    // Process the editable content
    ProcessViewContent(schemaModel, queryDetail, formAttribute, filteredEditable, attribute, false, currentHostCompany);

    // Create and append accordion panel for non-editable content
    // const divAccordionPanel = createTableComponent('div', '', '', '', 'accordionPanel');
    const divAccordionPanel = createTableComponent('div', { type: '', id: '', className: 'accordionPanel' });

    // const divPanel = createTableComponent('div', '', '', '');
    const divPanel = createTableComponent('div', { type: '', id: '', className: '' });
    // divPanel.innerHTML = '<div class="panel-heading"><div class="panel-title"><a class="collapsed" data-toggle="collapse"  href="#fieldsSec"><span>&nbsp;</span></a></div></div>';

    // divAccordionPanel.appendChild(divPanel);

    // const hiddenFieldDiv = createTableComponent('div', '', '', 'fieldsSec', 'panel-collapse collapse');
    const hiddenFieldDiv = createTableComponent('div', { type: '', id: 'fieldsSec', className: 'panel-collapse collapse' });
    // ProcessEditContent( schemaModel, queryDetail,  hiddenFieldDiv, filteredNonEditable, attribute );
    // divAccordionPanel.appendChild(hiddenFieldDiv);
    // formAttribute.appendChild(divAccordionPanel);
    items.push(divAccordionPanel)
    // setFormItems(divAccordionPanel)
    // }, [schemaModel, queryDetail, formAttribute, filteredEditable, filteredNonEditable]);
    setFormItems(attribute)
    // return null;
  };





  async function GetRawJson(itemID, schemaName) {
    let rawJSON;
    if (schemaName.includes("Archived"))
      schemaName = schemaName.replace("Archived", "")
    var roles = session?.user?.roles[0]; //'Admin'
    if (roles) {
      $.ajax({
        type: 'POST',
        url: ApiUrl.newUrl + '/api/getRoleAccess',
        headers: { jwt: localStorage.getItem("jwt") },
        data: { role: roles, type: schemaName, attrType: 'attribute', attr: '', objectId: itemID },
        async: false,
        success: function (result) {
          console.error("Sucessfully fetched role access:", result);
          if (result.rawjson)
            rawJSON = result.rawjson;
        },
        error: function (xhr, status, error) {
          console.error("Error fetching role access:", status, error);
        }
      });
    }
    if (!rawJSON) {
      $.ajax({
        type: 'GET',
        url: ApiUrl.newUrl + '/api/jsonschema/' + schemaName + '/rawjson',
        headers: { jwt: localStorage.getItem("jwt") },
        dataType: "json",
        async: false,
        success: function (result) {
          console.error("Successfully fetched raw JSON:", result);
          rawJSON = result.data;
        },
        error: function (xhr, status, error) {
          console.error("Error fetching raw JSON:", status, error);
        }
      });
    }

    setLoading(false);
    return rawJSON;
  }

  const onClose = () => {

    setShowWidget(false)
  };

  function handleRoleCompanyDependency(form, changedKey) {
    const { Role, Company } = form;
    if (changedKey === 'Role') {
      if (form.isHostCompanyValue || isHostCompanyValue) {
        if (Role.includes("Internal Admin") || Role.includes("Internal User")) {
          return { ...form, Role: Role.join(", ") };
          // Role: Role.flatMap(r => r.split(",").map(s => s.trim()))
        } else {
          return { ...form, Role: Role === "External User" ? "External User" : "Internal Admin" };
        }
      } else {
        return { ...form, Role: "External User" };
      }
    }

    return form;
  }

  const updateValue = (e, schemaKey, companyData = null) => {
    // console.log('e: ', e)
    // const {newValue} = (type == 'dropdown' && e)
    // const { type , value, checked, option } = (type == 'text' && e.target) || (type == 'dropdown' && e.target) ;
    const { id, type, value, checked, options, props } = e.target;
    // let value  = (type == 'text' && e.target) || (type == 'dropdown' && e);
    // console.log('va: ',value.defaultValue)
    // if (type == 'text') {
    //     let {value} = e.target
    // }

    if (currentSchemaName == 'Users' && schemaKey == 'Company') {
      const selected = companyData.find(option => option._id === value);

      setIsHostCompanyValue(selected.IsHostCompany)

    }

    if (currentSchemaName == 'Users' && schemaKey == 'Email') {
      if (formValues && formValues['Role'] === 'External User') {
        // formValues['UserID'] = formValues['Email']
        setFormValues((prev) => ({
          ...prev,
          // [schemaKey]: type == 'dropdown'? newValue : value,
          ["UserID"]: value,
        }));
      }
      setEmailValue(value);
      if (!emailRegex.test(value)) {
        setEmailErrorMessage("Please enter a valid email address");
      } else {
        setEmailErrorMessage("");
      }

      // if (!emailRegex.test(value) && value.includes("@")) {
      //   setEmailSuggestion(suggestDomains(value))
      // }
      // else{
      //   setEmailSuggestion([])
      // }
    }

    let newValue;
    if (type === 'checkbox') {
      newValue = checked;
    } else if (type == 'number' || type == 'text') {
      newValue = value
      // newValue = checked
    }
    else if (type == 'radio') {
      newValue = value == "true" ? true : false;
      if (currentSchemaName == 'Company' && schemaKey == 'IsHostCompany') {
        setIsHostCompany(newValue);
        //console.log('isHostCompany: ', isHostCompany);
        // if(isHostCompany){
        //   setFormValues((prev) => ({
        //     ...prev,
        //     "Approval Required": true,
        //   }));
        // console.log(formValues);
        // }
      }
    }
    else if (type === 'select-multiple') {
      newValue = Array.from(options).filter(option => option.selected).map(option => option.value);
    }
    // else if (type === 'select-one') {
    //   newValue = Array.from(options).filter(option => option.selected).map(option => option.value);
    // } 
    else if (type === 'date') {
      newValue = value?.toISOString?.() || null;
    }
    else {
      newValue = value
      //   Array.from(options).filter(option => option.selected).map(option => option.value);

    }

    // console.log('value: ', value);
    // console.log('type: ', type);
    // console.log('checked: ', checked);
    // console.log('schemaKey: ', schemaKey);
    // console.log('multiple: ', options);
    // console.log('id: ', id)

    // setFormValues((prev) => ({
    //   ...prev,
    //   // [schemaKey]: type == 'dropdown'? newValue : value,
    //   [schemaKey]: newValue,
    // }));

    setFormValues(prev => {
      // apply new value
      let updated = { ...prev, [schemaKey]: newValue };

      // Run interdependent logic for Role/Company BEFORE dirty check
      if (schemaKey === 'Role' || schemaKey === 'Company') {
        updated = handleRoleCompanyDependency(updated, schemaKey);
      }

      // Now run dirty check on final updated object
      const dirty = Object.keys(updated).some(key => {
        let updatedVal = updated[key] === "" ? null : updated[key];
        let originalVal = originalValues[key] === "" ? null : originalValues[key];

        // Normalize single-item arrays vs strings
        if (Array.isArray(originalVal) && originalVal.length === 1 && typeof updatedVal === "string") {
          originalVal = originalVal[0];
        }
        if (Array.isArray(updatedVal) && updatedVal.length === 1 && typeof originalVal === "string") {
          updatedVal = updatedVal[0];
        }

        return updatedVal !== originalVal;
      });

      setIsDirty(dirty);
      return updated;
    });




    if (errors[schemaKey]) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[schemaKey];
        return updatedErrors;
      });
    }
  };

  // const handleEmailSuggestionClick = (suggestion) => {
  //   setEmailValue(suggestion);

  //   setFormValues((prev) => ({
  //     ...prev,
  //     ["Email"]: suggestion,
  //   }));

  //   // if (formValues && formValues['Role'] === 'External User') {
  //   //   // formValues['UserID'] = formValues['Email']
  //   //   setFormValues((prev) => ({
  //   //     ...prev,
  //   //     ["UserID"]: suggestion,
  //   //   }));
  //   // }

  //   setEmailSuggestion([]);
  //   setEmailErrorMessage("");
  // };



  const updateDropdownValue = (e, schemaKey) => {
    const selectedId = e ? e.map(option => option.value) : [];

    setFormValues(prev => {
      const updated = { ...prev, [schemaKey]: selectedId };

      const dirty = Object.keys(updated).some(key => {
        let updatedVal = updated[key];
        let originalVal = originalValues[key];

        // Normalize empty values
        if (updatedVal === "") updatedVal = null;
        if (originalVal === "") originalVal = null;

        // Normalize react-select multiple: array of objects to array of values
        if (Array.isArray(updatedVal) && updatedVal.length && typeof updatedVal[0] === "object" && "value" in updatedVal[0]) {
          updatedVal = updatedVal.map(opt => opt.value);
        }
        if (Array.isArray(originalVal) && originalVal.length && typeof originalVal[0] === "object" && "value" in originalVal[0]) {
          originalVal = originalVal.map(opt => opt.value);
        }

        // Compare arrays ignoring order
        if (Array.isArray(updatedVal) && Array.isArray(originalVal)) {
          const sortedUpdated = [...updatedVal].sort();
          const sortedOriginal = [...originalVal].sort();
          return sortedUpdated.join("|") !== sortedOriginal.join("|");
        }

        return updatedVal !== originalVal;
      });

      setIsDirty(dirty);
      return updated;
    });

    if (errors[schemaKey]) {
      setErrors(prevErrors => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[schemaKey];
        return updatedErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // // Iterate over the form schema (rawJsonData) and check required fields
    // Object.keys(rawJsonData).forEach((key) => {
    //   const field = rawJsonData[key];
    //   console.log('field: ', field)

    //   // Check if the field is required and empty
    //   if (field.editable) {
    //     if (field.required && !formValues[key]) {
    //       newErrors[key] = `${field.label || key} is required.`;
    //       isValid = false;
    //     }

    //   }
    // });

    Object.keys(rawJsonData).forEach((key) => {
      const field = rawJsonData[key];
      // console.log( Array.isArray(formValues[key]) && formValues[key].length )
      // console.log(formValues[key])

      // if (field.editable && field.required && ( !formValues[key]  || (Array.isArray(formValues[key]) && formValues[key].length == 0)))
      if (field.editable && field.required && (formValues[key] === "" || formValues[key] === undefined || formValues[key] === null || (Array.isArray(formValues[key]) && formValues[key].length == 0))) {
        // for (const key in formValues) {
        //   // Check if the field is required and empty
        //   if (!formValues[key] && formValues[key] !== false) {
        newErrors[key] = `${key} is required`;
        //   }
        // }
      }
      if (
        isHostCompany &&
        (
          (formValues['Approvers'] === "" || formValues['Approvers'] === undefined || formValues['Approvers'] === null || (Array.isArray(formValues['Approvers']) && formValues['Approvers'].length === 0))
        ) &&
        key === 'Approvers'
      ) {
        newErrors['Approvers'] = `Please select at least one Approver`;
      }

      if (
        isHostCompany &&
        (
          (formValues['Reviewers'] === "" || formValues['Reviewers'] === undefined || formValues['Reviewers'] === null || (Array.isArray(formValues['Reviewers']) && formValues['Reviewers'].length === 0))
        ) &&
        key === 'Reviewers'
      ) {
        newErrors['Reviewers'] = `Please select at least one Reviewers`;
      }
    })



    // Set errors in state
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; //isValid;
  };




  async function createFun(currentSchemaName, currentItemID) {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      let newErrors = {}
      let hasError = false
      // if (!formValues.Name.trim()) {
      //   newErrors.Name = 'Please Enter Name'
      //   hasError = true
      // }
      // if (hasError) {
      //   setErrors(newErrors)
      // }

      if (validateForm()) {

        const validateEmail = (email) => {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(email);
        };

        // if (true) {
        if (currentSchemaName == 'TestSuite') {

          // if (formValues['Name'] == "" &&  Array.isArray(formValues['Package'].length) == 0 )  alert('Please Enter the required field')

          // switch (formValues['Name'] == "" ||  Array.isArray(formValues['Package'].length) == 0) {
          //   case formValues['Name'] == "" ||  Array.isArray(formValues['Package'].length) == 0:
          //     alert('Please Enter the required field')
          //     break;

          //   default:
          //     break;
          // }

          let fileList = [];
          let totalFileSize = 0;
          let fileCount = 0;
          let testCases = xmlData
          packages.forEach((ele) => {
            // console.log(ele);

            ele.fileList.forEach((e) => {
              fileCount++;

              // Check if the file already exists in the package
              let packageIndex = fileList.findIndex(pkg => pkg["File Name"] === e['File Name']);

              if (packageIndex === -1) {
                // If the file does not exist, Create a new one
                fileList.push({
                  "File Name": e['File Name'], //e.name,
                  "File Size": e['File Size'] //e.size
                  // "name": e.name,
                  // "size": e.size
                });
              } else {
                // If the file exists, update the file size if needed
                fileList[packageIndex]["File Size"] = e.size;
                //  fileList[packageIndex]["size"] = e.size;

              }
            });
          });

          // console.log('fileList: ', fileList)

          // Calculate the total file size
          fileList.forEach(file => {
            totalFileSize += file["File Size"];
            // totalFileSize += file["size"];

          });

          // Create a single package containing all the files
          let singlePackage = {
            "PackageFile": fileList,
            "Name": fileList[0]['File Name'],  // package Name
            "Batch File": formValues['Batch File'],
            "XML File": formValues['XML File'],
          };

          if (singlePackage["Batch File"] == null) {
            singlePackage["Batch File"] = "Run_TestSuiteName.bat"
          }
          if (singlePackage["XML File"] == null) {
            singlePackage["XML File"] = "<TestSuiteName>.xml"
          }

          // Add the single package to pArr
          let pArr = [singlePackage];

          let updateObj;

          updateObj = {
            [currentSchemaName]: {
              // ...formValues,
              "Package": pArr,
              "File Size": totalFileSize,
              "File Count": fileCount,
              "Name": formValues.Name,
              "Description": formValues.Description,
              "Clean-up Script": formValues['Clean-up Script'],
              "Is Performance?": formValues['Is Performance?'],
              "Test Cases": testCases,

            }
          }




          // console.log('pArr: ', updateObj)

          let apiPath = currentItemID ? ApiUrl.newUrl + "/api/dbjsonschema/TestSuitePackageFileCreation/id/" + currentItemID : ApiUrl.newUrl + "/api/dbjsonschema/TestSuitePackageFileCreation";
          var options = createCancelableAxiosOptions({
            headers: { jwt: localStorage.getItem("jwt") },
          });

          try {
            // Perform the API call to update and get the TestSuite data
            const resp = await axios.put(apiPath, { data: updateObj }, options);
            // console.log("resp: ", resp);

            const { data, error } = resp.data;
            if (resp.data.success) {
              console.log(currentSchemaName, ' created successfully');
              Swal.fire({
                title: `${mode}d`,
                // text: `${currentTitleName} has been ${mode}d`,
                text: `${formValues.Name} has been ${mode}d`,
                icon: 'success',
              }).then(() => {
                // Reload the page after successful deletion
                // window.location.reload();
                if (currentSchemaName == 'Users') {
                  router.push('/?redirectTo=/admin-center/users');
                } else if (currentSchemaName == 'Company') {
                  router.push('/?redirectTo=/admin-center/company');
                } else {
                  router.push('/?redirectTo=/jobs/all-jobs');
                }
              });
            } else {
              Swal.fire({
                title: 'Failed',
                text: `${formValues.Name} was not created`,
                icon: 'error',
                confirmButtonText: 'OK',
              });
            }

            if (error) {
              throw new Error(error);
            }

            // Extract the TestSuite ID and iterate through the Packages
            const TestSuiteId = data.TestSuite.id;
            data.TestSuite.Package.forEach(pack => {
              const packageIdId = pack.id;

              // Initialize the Resumable object for file uploads
              const resumable = new Resumable({
                target: `${ApiUrl.newUrl}/api/testSuiteFileUpload/TestSuite/${TestSuiteId}/${packageIdId}`,
                chunkSize: 4 * 1024 * 1024, // 4MB chunk size
                simultaneousUploads: 11,
                testChunks: false,
                throttleProgressCallbacks: 1
              });

              // Set up event listeners
              resumable.on('fileAdded', function (file) {
                // console.log('File added:', file);
                resumable.upload(); // Start upload automatically
              });

              resumable.on('progress', function () {
                const progress = Math.floor(resumable.progress() * 100);
                // console.log('Upload progress:', progress + '%');
                setUploadProgress(progress); // Update upload progress
              });

              resumable.on('fileSuccess', function (file, msg) {
                // console.log('Upload complete:', file);
                message.success('File uploaded successfully');
                setUploadProgress(0);

                // After file upload, make a POST request to update the server status
                const fileReq = $.ajax({
                  type: "POST",
                  url: `${ApiUrl.newUrl}/api/dbjsonschema/JobPackageSyncServerSetStatus/${TestSuiteId}`,
                  dataType: "json",
                  headers: {
                    jwt: localStorage.getItem("jwt"),
                  },
                  contentType: "application/json; charset=utf-8",
                  async: true,
                  success: function (result) {
                    message.success('Job submitted successfully');

                  },
                  error: function (jqXHR, textStatus, errorThrown) {
                    console.error('Status update error:', textStatus, errorThrown);
                    message.error('Failed to update job status');
                  }
                });
              });

              resumable.on('fileError', function (file, msg) {
                console.error('Upload error:', file, msg);
                message.error('Upload failed');
                setUploadProgress(0);
              });

              // Add files to Resumable instance for uploading
              pack.PackageFile.forEach(pckfile => {
                const objIndex = filesarr.findIndex(temp => temp.name === pckfile["File Name"]);
                if (objIndex !== -1) {
                  resumable.addFile(filesarr[objIndex]);
                } else {
                  console.error('File not found in array:', pckfile["File Name"]);
                }
              });
            });

          } catch (error) {
            if (!axios.isCancel(error)) {
              console.error('Error:', error);
              message.error('An error occurred during the operation');
            }
          }

        }
        else if (currentSchemaName == 'Users') {

          let email = formValues && formValues['Email']
          let companyId = formValues && formValues['Company']
          if (!validateEmail(email)) {
            return alert("Please enter a valid email address")
          }

          let domainValue = ''
          if (companyId) {
            $.ajax({
              method: "GET",
              url: ApiUrl.newUrl + '/api/dbjsonschema/schema/' + 'Company' + '/id/' + companyId,
              dataType: "json",
              async: false,
              headers: { jwt: localStorage.getItem("jwt") },
              success: function (result) {
                let queryDetail = result.data['Company'.toLocaleLowerCase()];
                domainValue = queryDetail['companydomain']
                console.log('Company details fetched successfully');

              },
              error: function (xhr, status, error) {
                console.error("Error fetching company details:", status, error);
              }
            });
          }

          // Commented to stop validating user mail domain with company domain

          if (domainValue && !formValues['Email'].includes(domainValue)) {
            // return alert('Please enter valid email address match to company value')
            return Swal.fire({
              // title: "Good job!",
              text: "Please enter valid email address match to company value",
              icon: "warning"
            });
          }

          if (mode == 'Edit') {
            let apiPath = ApiUrl.newUrl + "/api/adminUpdateUser"
            var options = createCancelableAxiosOptions({
              headers: { jwt: localStorage.getItem("jwt") },
            });

            let upadateObj = {
              ...formValues,
              _id: currentItemID
            }
            try {

              var resp = await axios.post(apiPath, upadateObj, options);
              // var resp = await axios.post(apiPath, {}, options);
              // console.log('resp: ', resp)
              var { data, error } = resp.data;

              let userId = upadateObj.UserID;
              if (resp.data.success) {
                console.log('User has been updated');
                // console.log('resp: ', resp)
                Swal.fire({
                  title: `Updated`,
                  // text: `${currentTitleName} has been ${mode}d`,
                  text: `${userId} has been updated`,
                  icon: 'success',
                }).then(() => {
                  setShowWidget(false);
                  onRefresh();

                  // window.location.reload();
                  // if (currentSchemaName == 'Users' && userEditProfile == null) {
                  //   router.push('/?redirectTo=/admin-center/users');
                  // } else if (currentSchemaName == 'Users' && userEditProfile === "userEditProfile") {
                  //   router.push('/?redirectTo=/jobs/all-jobs');
                  // } else if (currentSchemaName == 'Company') {
                  //   router.push('/?redirectTo=/admin-center/company');
                  // } else {
                  //   router.push('/?redirectTo=/jobs/all-jobs');
                  // }
                });
              } else {
                Swal.fire({
                  title: 'Failed',
                  text: `${userId} was not updated`,
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              }
              // console.log(resp.data);
              // setLoading(true);
              // setTimeout(() => {
              //     router.push('/');
              // }, 1000);
            }
            catch (error) {
              if (!axios.isCancel(error)) {
                console.error(error);
                alert('Error while updating user')
              }
            }
          }
          else {

            if (formValues['Email']) {
              formValues['Email'] = formValues['Email'].toLowerCase();
            }
            if (formValues['UserID']) {
              formValues['UserID'] = formValues['UserID'].toLowerCase();
            }
            if (formValues['Role']) {
              formValues['Role'] = Array.isArray(formValues['Role'])
                ? formValues['Role'].flatMap(r => r.split(",").map(s => s.trim()))
                : formValues['Role'].split(",").map(s => s.trim());
            }
            else {
              // If UserID not set, fallback to email
              formValues['UserID'] = formValues['Email'];
            }

            let apiPath = ApiUrl.newUrl + "/api/adminCreateUser"
            var options = createCancelableAxiosOptions({
              headers: { jwt: localStorage.getItem("jwt") },
            });
            try {

              var resp = await axios.post(apiPath, formValues, options);
              // var resp = await axios.post(apiPath, {}, options);
              // console.log('resp: ', resp)
              var { data, error } = resp.data;
              if (resp.data.message === "User already Exists") {
                return Swal.fire({
                  // title: "Good job!",
                  text: "User Already Exists!",
                  icon: "warning"
                });
              }
              let userId = resp.data.userCreateResp.users[0].UserID;

              if (resp.data.success) {
                console.log('User created successfully')
                // console.log('resp: ', resp)
                Swal.fire({
                  title: `Created`,
                  // text: `${currentTitleName} has been ${mode}d`,
                  text: `${userId} User has been ${mode}d`,
                  icon: 'success',
                }).then(() => {
                  setShowWidget(false);
                  onRefresh();
                  // window.location.reload();
                  // if (currentSchemaName == 'Users') {
                  //   router.push('/?redirectTo=/admin-center/users');
                  // } else if (currentSchemaName == 'Company') {
                  //   router.push('/?redirectTo=/admin-center/company');
                  // } else {
                  //   router.push('/?redirectTo=/jobs/all-jobs');
                  // }
                });
              } else {
                Swal.fire({
                  title: 'Failed',
                  text: `${userId} was not ${mode}d`,
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              }
              // console.log(resp.data);
              // setLoading(true);
              // setTimeout(() => {
              //     router.push('/');
              // }, 1000);
            }
            catch (error) {
              if (!axios.isCancel(error)) {
                console.error('Could not create user: ', error);
                alert('Error while creating user')
              }
            }
          }


        }
        else {
          let updateObj = {
            // [currentSchemaName]: {
            ...formValues,
            // }
          }


          // console.log('pArr: ', updateObj)

          if (currentSchemaName == "TestExecution") {
            updateObj.Status = 1
          }

          let apiPath = currentItemID ? ApiUrl.newUrl + "/api/dbjsonschema/schema/" + currentSchemaName + "/id/" + currentItemID : ApiUrl.newUrl + "/api/dbjsonschema/schema/" + currentSchemaName;
          var options = createCancelableAxiosOptions({
            headers: { jwt: localStorage.getItem("jwt") },
          });

          try {
            const resp = mode === 'Create'
              ? await axios.post(apiPath, { data: updateObj }, options)
              : await axios.put(apiPath, { data: updateObj }, options);

            const { data, error } = resp.data;
            const createUpdateValue = mode === 'Create' ? 'Created' : 'Updated';

            if (resp.data.success) {
              const schemaData = resp.data.data?.[currentSchemaName.toLowerCase()];
              const recordId = Array.isArray(schemaData) ? schemaData?.[0]?._id : schemaData?._id;

              const fileKeys = Object.keys(rawJsonData).filter(
                (key) => rawJsonData[key].isFile === true
              );

              if (
                fileKeys.length > 0 &&
                uploadedFilesRef.current &&
                Object.keys(uploadedFilesRef.current).length > 0
              ) {
                // Upload all files sequentially
                for (const fileAttribute of fileKeys) {
                  const files = uploadedFilesRef.current[fileAttribute]; // could be single file or array
                  if (!files) continue;

                  if (Array.isArray(files)) {
                    for (const f of files) {
                      try {
                        await genericFileUpload(
                          f.originFileObj || f,
                          currentSchemaName,
                          recordId,
                          fileAttribute
                        );
                      } catch (err) {
                        console.error(`Upload failed for ${f.name}:`, err);
                        message.error(`${f.name} upload failed`);
                      }
                    }
                  } else {
                    try {
                      await genericFileUpload(
                        files.originFileObj || files,
                        currentSchemaName,
                        recordId,
                        fileAttribute
                      );
                    } catch (err) {
                      console.error(`Upload failed for ${files.name}:`, err);
                      message.error(`${files.name} upload failed`);
                    }
                  }
                }
              }

              Swal.fire({
                title: createUpdateValue,
                text: `${formValues.Name} has been ${createUpdateValue}`,
                icon: 'success',
              }).then(() => {
                setShowWidget(false);
                onRefresh();
              });
            } else {
              Swal.fire({
                title: 'Failed',
                text: `${formValues.Name} was not ${createUpdateValue}`,
                icon: 'error',
                confirmButtonText: 'OK',
              });
            }
          } catch (err) {
            console.error("Error in create/update:", err);
            Swal.fire({
              title: 'Error',
              text: 'Something went wrong while saving.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        }
      }
      else {
        alert('Please Fill all mandatory Fields')
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  }


  // const customRequest = ({ file, packlength }) => {
  //     //  files.push(file.originFileObj)
  //    file && setfilesarr(file.originFileObj);
  //     // resumableRef.current.addFile(file.originFileObj);
  //   };

  const customRequest = ({ file, packlength }) => {

    if (packages[0]['fileList'].length != 0) {
      // console.log('inside........ ')
      $('#browseButtonId').hide();  // Hide the browse button
      $('#deleteButtonId').show();
    }

    //  files.push(file.originFileObj)
    if (file.originFileObj) {
      var tempArr = filesarr;
      const nameExists = tempArr.some(item => item.name === file.originFileObj.name);
      if (!nameExists) {
        filesarr.push(file.originFileObj)
        setfilesarr(tempArr);
      }
      // resumableRef.current.addFile(file.originFileObj);
    }
  };

  const handleFileRemove = (schemaKey) => {

    setPackages([{
      packageId: 1,
      fileList: [],
    }])


    setFormValues((prev) => ({
      ...prev,
      [schemaKey]: []

      //  [schemaKey]: [{
      //     packageId: 1,
      //     fileList: [],
      //   }]

    }));

    setFileNameStore('')

    packageFileName = ''

    // $('#deleteButtonId').on('click', function() {
    //   toggleButtons(false);
    // });

    // document.getElementById('detailAttr_Package').remove = null

  };

  function genericFileUpload(file, schemaName, itemId, attributeName) {
    return new Promise((resolve, reject) => {
      const resumable = new Resumable({
        target: `${ApiUrl.newUrl}/api/GenericFileUpload/${schemaName}/${itemId}/${attributeName}`,
        chunkSize: 4 * 1024 * 1024,
        simultaneousUploads: 1,
        testChunks: false,
        throttleProgressCallbacks: 1,
        maxChunkRetries: 3,
        chunkRetryInterval: 1000,
        uploadMethod: 'POST',
        method: 'multipart'
      });

      if (!file || typeof file !== 'object') {
        reject('Invalid file');
        return;
      }

      let isCompleted = false;
      const timeout = setTimeout(() => {
        if (!isCompleted) {
          resumable.cancel();
          reject('Upload timeout');
        }
      }, 900000);

      resumable.on('fileAdded', () => resumable.upload());

      resumable.on('fileSuccess', (file, msg) => {
        if (isCompleted) return;
        isCompleted = true;
        clearTimeout(timeout);
        resolve(msg);
      });

      resumable.on('fileError', (file, msg) => {
        if (isCompleted) return;
        isCompleted = true;
        clearTimeout(timeout);
        reject(msg);
      });

      resumable.on('progress', () => {
        if (typeof setUploadProgress === 'function') {
          setUploadProgress(Math.floor(resumable.progress() * 100));
        }
      });

      resumable.addFile(file);
    });
  }

  async function handleFileUpload(info, packageId) {
    const { fileList } = info;
    let updatedPackages = [...packages];

    if (!fileList || fileList.length === 0) {
      message.error("No files provided");
      return;
    }

    const mappedFiles = fileList.map((f) => ({
      uid: f.uid,
      "File Name": f.name,
      status: f.status,
      "File Size": f.size,
      percent: f.percent,
    }));

    updatedPackages = packages.map((pkg) => {
      if (pkg.packageId === packageId) {
        pkg.fileList = mappedFiles;
      }
      return pkg;
    });

    setShowFileList(true);

    const fileNamesArray = mappedFiles.map((f) => f["File Name"]);

    setFileNameStore(fileNamesArray);
    setPackages(updatedPackages);

    setFormValues((prev) => ({
      ...prev,
      Package: fileNamesArray,
    }));

    document.getElementById("detailAttr_Package").value = JSON.stringify(fileNamesArray);

    addPackage = fileNamesArray.length > 0;

    // upload each file
    for (const f of fileList) {
      try {
        await genericFileUpload(f.originFileObj, "Job", packageId, "Resume");
        message.success(`${f.name} uploaded successfully`);
      } catch (err) {
        console.error("Upload failed:", err);
        message.error(`${f.name} upload failed`);
      }
    }

    customRequest(info, packages.length);

    return false;
  }



  // Function to handle adding more files to a package
  function handleMoreFile(info, packageId) {
    // Call the same handleFileUpload function as above
    handleFileUpload(info, packageId);
  }

  function addNewPackage() {
    const newPackageId = packages.length + 1;
    setPackages([
      ...packages,
      {
        packageId: newPackageId,
        fileList: [],
      },
    ]);
  }

  const deleteFile = () => {
    setPackages([{
      packageId: 1,
      fileList: [],
    }])
    setShowFileList(false);
  }

  // const getActions = async () => {
  //   const result = await $.ajax({
  //     type: "GET",
  //     url: `${ApiUrl.newUrl}/api/jsonschema/${currentSchemaName}/rawjson`,
  //     dataType: "json",
  //     headers: { jwt: localStorage.getItem("jwt") },
  //   });
  //   const statusMap = currentStatusActionData?.status || {};
  //   const allActions = result?.data?.Actions?.items || result?.data?.Actions?.items;

  //   const enabledActions = allActions.filter(action => statusMap[action.Name] === "1");

  //   const actionMenuItems = enabledActions.length > 0
  //     ? enabledActions.map((action, index) => ({
  //       key: `${index + 1}`,
  //       label: (
  //         <Link legacyBehavior href="#">
  //           <a onClick={() => handleActionClick(action)} style={{ textDecoration: "none" }}>
  //             {action.Name}
  //           </a>
  //         </Link>
  //       )
  //     }))
  //     : [{
  //       key: "no-action",
  //       label: <span style={{ color: "gray", cursor: "default" }}>No Actions</span>,
  //       disabled: true
  //     }];

  //   setActionMenuItems(actionMenuItems);



  //   // setActionMenuItems(enabledActions);
  //   setDropdownVisible(prev => !prev);
  // };

  // const handleActionClick = async (action) => {
  //   setDropdownVisible(false);
  //   console.log("Run:", action.Name);

  //   try {
  //     const moduleObj = await import(`../../public/action/${action.FileName}`);

  //     const [className, ActionClass] =
  //       Object.entries(moduleObj).find(
  //         ([_, value]) => typeof value === "function"
  //       ) || [];

  //     if (ActionClass) {
  //       const objAction = new ActionClass();
  //       console.log(objAction);
  //       objAction.initializingAction(router, currentSchemaName, currentItemID, '', refreshGenericTable)

  //     }
  //     else {
  //       console.error("No valid class found in moduleObj");
  //     }
  //   } catch (error) {
  //     console.error("Error importing genericAction:", error);
  //   }
  // };

  // const menu = (
  //   <Menu
  //     items={actionMenuItems}
  //   />
  // );
  // State for action buttons

  // Split actions into inside/outside
  const splitActions = (rawJsonData, currentStatusActionData) => {
    if (!rawJsonData || !currentStatusActionData) return { inside: [], outside: [] };
    const actions = rawJsonData?.data?.Actions?.items || rawJsonData?.Actions?.items || [];
    const statusActions = currentStatusActionData?.status || {};
    const objId = currentStatusActionData.ObjId;
    const currentSchema = currentSchemaName || currentStatusActionData.ObjType || "";

    const inside = [];
    const outside = [];

    const getIconComponent = (icon) => {
      if (!icon) return null;

      const AntdIcon = Icons[icon];
      if (AntdIcon) {
        return (
          <AntdIcon
            style={{
              fontSize: 13,
              paddingBottom: 2,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              // color: "#4A5568"
              color: "#475475",
            }}
          />
        );
      }

      return (
        <Image src={icon} alt={icon} width={14} height={14} preview={false} />
      );
    };

    actions.forEach(({ Name, FileName, Icon, Class = "" }) => {
      if (statusActions[Name] != "1") return;

      const classParts = Class.split(" ").filter(Boolean);
      const isContextDisable = classParts.includes("context-disable");
      const btnStyleClass = classParts[classParts.length - 1] || "";
      const iconElement = getIconComponent(Icon);

      if (isContextDisable) {
        // Outside buttons
        outside.push(
          <Button
            type='secondary'
            key={Name}
            title={Name}
            className={`btn-icon-round ${btnStyleClass}`}
            onClick={() =>
              getGenericAction(Name, objId, FileName, currentSchema, "outside")
            }
          >
            {iconElement}

          </Button>
        );
      } else {
        // Inside dropdown
        inside.push(
          <Menu.Item
            key={Name}
            onClick={() =>
              getGenericAction(Name, objId, FileName, currentSchema)
            }
            icon={iconElement}
            className={btnStyleClass}
          >
            {Name}
          </Menu.Item>
        );
      }
    });
    if (inside.length === 0) {
      inside.push(
        <Menu.Item key="no-action" disabled>
          No Actions
        </Menu.Item>
      );
    }

    return { inside, outside };
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    async function fetchActions() {
      const { inside, outside } = await splitActions(rawJsonData, currentStatusActionData);
      setDropdownButtons(inside);
      setIndependentButtons(outside);
    }

    if (mode === 'Edit' || mode === 'View') {
      fetchActions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawJsonData, currentStatusActionData, mode]);
  const getGenericAction = async (action, jobid, fileName, schemaName) => {
    try {
      if (fileName == "event.js") fileName = "eventShowAction.js";

      const moduleObj = await import(`../../pages/action/${fileName}`);
      const [_, ActionClass] =
        Object.entries(moduleObj).find(([, value]) => typeof value === "function") || [];

      if (ActionClass) {
        const objAction = new ActionClass();
        // deactivationRef.current = objAction;

        if (action === "Download" || action === "Log Download") {
          const downloadModule = await import(`../../pages/action/download`);
          const { default: downloadAction } = downloadModule;
          const downloader = new downloadAction();
          downloader.loadFunction(jobid, "", schemaName, "", "", "", action === "Log Download", "");
        } else {
          objAction.initializingAction(
            router,
            schemaName,
            jobid,
            setactionGenericElement,
            onRefresh,
            setShowWidget,
            setIsModalOpen,
            setgenericModalTitle,
          );
        }
      } else {
        console.error("No valid class found for action:", action);
      }
    } catch (error) {
      console.error("Failed to execute action:", action, error);
    }
  };





  // useEffect(() => {
  //   if (mode == 'Create' && currentSchemaName == "TestSuite") {
  //     // LoadCreateContent(rawJsonData)

  //     // if (fileNameStore != '') {
  //     //   let fileNameValue = document.getElementById('detailAttr_Package').value = fileNameStore != '' && fileNameStore
  //     //   //  let fileNameValue = document.getElementById('detailAttr_Package').reload()
  //     //   console.log('fileNameValue: ', fileNameValue)

  //     //   let parentElement = document.getElementById('buttons-id')

  //     //   let uploadButton = document.getElementById('upload-Package')
  //     //   let deleteButton = document.getElementById('delete-Package')

  //     //   // parentElement.remove(deleteButton,uploadButton)
  //     //   // uploadButton.remove()
  //     //   // parentElement.append(deleteButton)

  //     //   console.log('parentElement: ', parentElement)

  //     // }


  //   }
  //   else if (mode == 'Edit' && currentSchemaName == "TestSuite") {
  //   }

  // },
  //   [packages]
  //   // [formValues && formValues.Package ]
  // )

  const isExternalUserRole = currentSchemaName == 'Users' && formValues['Role'] == 'External User';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    isMountedRef.current = true;
    if (mode == 'Create') {
      LoadCreateContent(rawJsonData, 'Create')
    }
    if (mode == 'Edit') {
      (rawJsonData, queryDetail, formAttribute, 'Edit');
    }

    return () => {
      isMountedRef.current = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors, isHostCompanyValue, isHostCompany, emailValue, isExternalUserRole, userRole])


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (mode === 'Edit' && Object.keys(formValues).length > 0) {
      LoadEditContent(rawJsonData, queryDetail, formAttribute, 'Edit');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues]);




  return (
    <>

      {currentSchemaName != 'TestSuite' && (mode == 'Edit' || mode == 'Create' || mode == 'View') &&
        // <Drawer title={(mode == 'Create' && `Create New ${currentSchemaName}`) || (mode == 'Edit' && `Edit ${currentSchemaName}`)} placement="right" open={open1} onClose={onClose} width={540} className="custom-drawer">
        <Drawer
          title={
            (mode === 'Create') ? `Create New ${currentTitleName}` : (mode === 'Edit') ? `Edit ${currentTitleName} Data` : (currentSchemaName === "Approval")
              ? (mode === 'View' ? `View ${currentTitleName} - ${jobID}` : "Edit Mode")
              : (mode === 'View' ? `View ${currentTitleName} data` : "Edit Mode")
          }
          placement="right" extra={<Col>
            <Space size={15}>
              {/* {(mode == 'Edit' || mode == 'View') && <Tooltip title = 'Actions'>
                <Button type='secondary' onClick={() => getActions()}
                  title={(mode === 'Edit' || mode === 'View')}
                //  className="btn-icon-round"
                >

                  <Image
                    src={'/images/dot.svg'}
                    alt="Action"
                    height={11}
                    width={11}
                    preview={false}
                    style={{ filter: 'contrast(1.4) brightness(10)' }}
                  />
                </Button>
              </Tooltip>} */}
              {(mode === "Edit" || mode === 'View') && (
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>

                  {/* {dropdownButtons && ( */}
                  {dropdownButtons.length > 1 && (<Dropdown
                    overlay={<Menu>{dropdownButtons}</Menu>}
                    trigger={["click"]}
                    placement="bottomRight"
                  >
                    <Button type="secondary" className="btn-icon-round">
                      <Image
                        src="/images/dot.svg"
                        alt="Actions"
                        height={11}
                        width={11}
                        preview={false}
                        style={{ filter: 'contrast(1.4) brightness(10)' }}
                      />
                    </Button>
                  </Dropdown>)}
                  {/* )} */}

                  {independentButtons}
                </div>
              )}


              {mode == 'Edit' && isDirty && <Button type="primary" style={{ background: 'linear-gradient(135deg, #1e3a5f 0%, #4f6ef7 100%)', borderColor: 'transparent' }} onClick={() => createFun(currentSchemaName, currentItemID)} >Save</Button>}
              {mode == 'Create' && <Button type="primary" style={{ background: 'linear-gradient(135deg, #1e3a5f 0%, #4f6ef7 100%)', borderColor: 'transparent' }} onClick={() => createFun(currentSchemaName)} >Create</Button>}
              <Button type='secondary' onClick={onClose}>Close</Button>

            </Space>
          </Col >}

          open={open1}
          // onClose={onClose} 
          closeIcon={null}
          width={540} className="custom-drawer"
        >
          <div className='form-wrap'>
            <div className='form-div'>

              <Row className='mb-25'>
                <Col span="24">

                  {/* {loading ? (<div>Loading...</div>) : formItems ? (<ul>{formItems}</ul>) : (<div>No Data</div>)} */}

                  {loading ? (<div>Loading...</div>) : formItems ? (formItems.map((element) =>
                    <>
                      <ul>{element}</ul>
                    </>)) : (<div>No Data</div>)}


                </Col>

              </Row>


            </div>
          </div>
        </Drawer >
      }
    </>
  )
};

